import { differenceInYears, isToday, isFuture, parseISO, parse, isValid } from "date-fns";
import { E as Environment, t as trackSegmentEvent, r as resetSegmentUser, i as identifySegmentUser, l as logSegmentPageView, g as getQueryParam, m as mergeQueryParam, s as stripQueryParam, a as toQueryString, b as isEnvironmentLocal, c as isEnvironmentStaging, d as isEnvironmentProduction, A as ApiClient, e as loggerUtils, f as getEnvironment, h as appendQueryParams, j as ApiError, k as getSafeNextQueryParam, n as getCurrentPath } from "./api-jmrH4cd3.js";
import { q, u, p, y, o, z, B, C, D, x, w, v, F, G } from "./api-jmrH4cd3.js";
import constate from "constate";
import { useRef, useLayoutEffect, useState, useEffect, useCallback, useMemo } from "react";
import { useLocation, useHistory, Redirect } from "react-router-dom";
import { pickBy, identity, isEqual, partial, intersection, isString, uniq, first, snakeCase } from "lodash-es";
import arLocale from "date-fns/locale/ar-SA";
import enUsLocale from "date-fns/locale/en-US";
import esLocale from "date-fns/locale/es";
import faIrLocale from "date-fns/locale/fa-IR";
import frLocale from "date-fns/locale/fr";
import hiLocale from "date-fns/locale/hi";
import htLocale from "date-fns/locale/ht";
import huLocale from "date-fns/locale/hu";
import koLocale from "date-fns/locale/ko";
import nlLocale from "date-fns/locale/nl";
import plLocale from "date-fns/locale/pl";
import ptLocale from "date-fns/locale/pt";
import ruLocale from "date-fns/locale/ru";
import ukLocale from "date-fns/locale/uk";
import viLocale from "date-fns/locale/vi";
import zhCnLocale from "date-fns/locale/zh-CN";
import zhTwLocale from "date-fns/locale/zh-TW";
import buildFormatLongFn from "date-fns/locale/_lib/buildFormatLongFn";
import buildLocalizeFn from "date-fns/locale/_lib/buildLocalizeFn";
import buildLocalizeFn$1 from "date-fns/locale/_lib/buildLocalizeFn/index";
import Cookies from "universal-cookie";
import { QueryClient } from "react-query";
import * as Sentry from "@sentry/react";
import { useAuthSession, useAuthenticatedUser, SESSIONS_ENDPOINT } from "./AuthContextApis.js";
import { asyncWithLDProvider, useLDClient } from "launchdarkly-react-client-sdk";
import { format, utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { Temporal, toTemporalInstant } from "@js-temporal/polyfill";
import pluralize from "pluralize";
import * as Yup from "yup";
import { jsx } from "react/jsx-runtime";
import { Provider } from "launchdarkly-react-client-sdk/lib/context";
import { Integrations } from "@sentry/tracing";
import { conformToMask } from "react-text-mask";
import asyncRetry from "async-retry";
import { http } from "msw";
function AddressFactory(extraProps) {
  return {
    id: 1,
    full_name: "Bilbo Baggins",
    line1: "123 Underhill Way",
    city: "The Shire",
    state: "MA",
    postal_code: "00100",
    country: "US",
    phone_country: "US",
    phone_number: "9876543210",
    ...extraProps
  };
}
function createAddressFromPartialValues(partialValues) {
  return {
    full_name: "",
    line1: "",
    city: "",
    state: "",
    postal_code: "",
    // SUPPORT-19535 Non-empty country value required.
    country: "US",
    ...partialValues
  };
}
const ADULT_MINIMUM_AGE = 18;
const INDEPENDENT_MINOR_MINIMUM_AGE = 13;
function calculateAge(birthday) {
  return differenceInYears(/* @__PURE__ */ new Date(), birthday);
}
function hasMinimumAge(birthday, minimumAgeInYears) {
  return calculateAge(birthday) >= minimumAgeInYears;
}
function isAdult(birthday) {
  return hasMinimumAge(birthday, ADULT_MINIMUM_AGE);
}
function getTracesSampleRate(environment) {
  const prodTracesSampleRate = 0.1;
  const nonProdTracesSampleRate = 1;
  return environment === Environment.PRODUCTION ? prodTracesSampleRate : nonProdTracesSampleRate;
}
const COLOR_ERROR_ID_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const getRandomErrorId = () => {
  let errorId = "";
  for (let i = 0; i < 6; i += 1) {
    if (i !== 0 && i % 2 === 0) {
      errorId += "-";
    }
    errorId += COLOR_ERROR_ID_CHARACTERS[Math.floor(Math.random() * COLOR_ERROR_ID_CHARACTERS.length)];
  }
  return errorId;
};
let latestColorErrorId = "";
function getLatestSentryEventId() {
  return latestColorErrorId;
}
function initSentry(environment, config) {
  const { dsn } = config;
  if (!dsn) {
    console.warn("Unable to determine Sentry DSN");
    return;
  }
  const sentryOptions = {
    ...config,
    environment,
    // `local`, `staging`, `testing`, `production`, or `unknown`
    integrations: [new Integrations.BrowserTracing()],
    denyUrls: [/cdn\.cookielaw\.org/i],
    // Removed cookie consent dialog on the sites, but leaving this in case we add it back
    tracesSampleRate: getTracesSampleRate(environment),
    beforeSend: (event) => {
      const colorErrorId = getRandomErrorId();
      latestColorErrorId = colorErrorId;
      return {
        ...event,
        tags: {
          ...event.tags,
          colorErrorId
        }
      };
    }
  };
  Sentry.init(sentryOptions);
}
let monitoringIsInitialized = false;
function initMonitoring(monitoringConfig) {
  if (monitoringIsInitialized) {
    return;
  }
  monitoringIsInitialized = true;
  const { environment, sentryConfig } = monitoringConfig;
  initSentry(environment, sentryConfig);
}
function getInstrumentedApp(App, monitoringConfig) {
  initMonitoring(monitoringConfig);
  return Sentry.withProfiler(App);
}
const trackAnalyticsEvent = (event, properties = {}) => {
  setTimeout(() => {
    trackSegmentEvent(event, properties);
  }, 0);
};
const identifyAnalyticsUser = (props) => {
  setTimeout(() => {
    identifySegmentUser(props);
  }, 0);
};
const resetAnalyticsUser = () => {
  setTimeout(() => {
    resetSegmentUser();
  }, 0);
};
const logAnalyticsPageView = (name, properties) => {
  setTimeout(() => {
    logSegmentPageView(name, properties);
  }, 0);
};
function useReferrer() {
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;
  const currentPathRef = useRef(document.referrer);
  const previousPathRef = useRef("");
  useLayoutEffect(() => {
    previousPathRef.current = currentPathRef.current;
    currentPathRef.current = path;
  }, [path]);
  return previousPathRef;
}
const [ReferrerProvider, useReferrerContext] = constate(useReferrer);
const dateFormats$4 = {
  full: "EEEE ፣d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
const timeFormats$3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$5 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong$5 = {
  date: buildFormatLongFn({
    formats: dateFormats$4,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$3,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$5,
    defaultWidth: "full"
  })
};
const defaultMonthValues$4 = [
  "ጃንዩወሪ",
  "ፌብሩወሪ",
  "ማርች",
  "ኤፕሪል",
  "ሜይ",
  "ጁን",
  "ጁላይ",
  "ኦገስት",
  "ሴፕቴምበር",
  "ኦክቶበር",
  "ኖቬምበር",
  "ዲሴምበር"
];
const abbreviatedMonthValues$1 = [
  "ጃንዩ",
  "ፌብሩ",
  "ማርች",
  "ኤፕሪ",
  "ሜይ",
  "ጁን",
  "ጁላይ",
  "ኦገስ",
  "ሴፕቴ",
  "ኦክቶ",
  "ኖቬም",
  "ዲሴም"
];
const monthValues$5 = {
  narrow: abbreviatedMonthValues$1,
  abbreviated: abbreviatedMonthValues$1,
  wide: defaultMonthValues$4
};
const defaultDayValues$4 = ["እሑድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];
const abbreviatedDayValues$1 = ["እሑድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];
const dayValues$5 = {
  narrow: abbreviatedDayValues$1,
  short: abbreviatedDayValues$1,
  abbreviated: abbreviatedDayValues$1,
  wide: defaultDayValues$4
};
const defaultDayPeriodValues$5 = {
  am: "ጥዋት",
  pm: "ከሰዓት",
  midnight: "እኩለ ሌሊት",
  noon: "ቀትር",
  morning: "ጥዋት1",
  afternoon: "ከሰዓት በኋላ",
  evening: "ማታ",
  night: "ሌሊት"
};
const abbreviatedDayPeriodValues$1 = {
  ...defaultDayPeriodValues$5,
  am: "ጥዋት",
  pm: "ከሰዓት"
};
const dayPeriodValues$5 = {
  narrow: abbreviatedDayPeriodValues$1,
  abbreviated: abbreviatedDayPeriodValues$1,
  wide: defaultDayPeriodValues$5
};
const defaultFormattingDayPeriodValues$4 = {
  am: "ጥዋት",
  pm: "ከሰዓት",
  midnight: "እኩለ ሌሊት",
  noon: "ቀትር",
  morning: "ጥዋት1",
  afternoon: "ከሰዓት በኋላ",
  evening: "ማታ",
  night: "ሌሊት"
};
const abbreviatedFormattingDayPeriodValues$1 = {
  ...defaultFormattingDayPeriodValues$4,
  am: "ጥዋት",
  pm: "ከሰዓት"
};
const formattingDayPeriodValues$4 = {
  narrow: abbreviatedFormattingDayPeriodValues$1,
  abbreviated: abbreviatedFormattingDayPeriodValues$1,
  wide: defaultFormattingDayPeriodValues$4
};
const localize$5 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$5,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$5,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$5,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$4,
    defaultFormattingWidth: "wide"
  })
};
const amLocale = {
  code: "am",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$5,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$5,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const dateTimeFormats$4 = {
  full: "{{date}} 'sa' {{time}}",
  long: "{{date}} 'sa' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$4 = {
  date: enUsLocale.formatLong.date,
  time: enUsLocale.formatLong.time,
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$4,
    defaultWidth: "full"
  })
};
const formatRelativeLocale$1 = {
  lastWeek: "'noong nakaraang' eeee 'ng' p",
  yesterday: "'kahapon ng' p",
  today: "'ngayong ng' p",
  tomorrow: "'bukas ng' p",
  nextWeek: "'susunod na' eeee 'ng' p",
  other: "P"
};
function formatRelative$1(token) {
  return formatRelativeLocale$1[token];
}
const monthValues$4 = {
  narrow: ["E", "P", "M", "A", "M", "H", "H", "A", "S", "O", "N", "D"],
  abbreviated: ["Ene", "Peb", "Mar", "Abr", "May", "Hun", "Hul", "Ago", "Set", "Okt", "Nob", "Dis"],
  wide: [
    "Enero",
    "Pebrero",
    "Marso",
    "Abril",
    "Mayo",
    "Hunyo",
    "Hulyo",
    "Agosto",
    "Setyembre",
    "Oktubre",
    "Nobyembre",
    "Disyembre"
  ]
};
const shortDayValues = ["Lin", "Lun", "Mar", "Miy", "Huw", "Biy", "Sab"];
const dayValues$4 = {
  narrow: ["Li", "Lu", "Ma", "Mi", "Hu", "Bi", "Sa"],
  short: shortDayValues,
  abbreviated: shortDayValues,
  wide: ["Linggo", "Lunes", "Martes", "Miyerkules", "Huwebes", "Biyernes", "Sabado"]
};
const defaultFormattingDayPeriodValues$3 = {
  am: "AM",
  pm: "PM",
  midnight: "ng hatinggabi",
  noon: "ng tanghali",
  morning: "ng umaga",
  afternoon: "ng hapon",
  evening: "ng gabi",
  night: "ng gabi"
};
const formattingDayPeriodValues$3 = {
  narrow: {
    ...defaultFormattingDayPeriodValues$3,
    am: "A",
    pm: "P"
  },
  abbreviated: defaultFormattingDayPeriodValues$3,
  wide: defaultFormattingDayPeriodValues$3
};
const defaultDayPeriodValues$4 = {
  am: "AM",
  pm: "PM",
  midnight: "hatinggabi",
  noon: "tanghali",
  morning: "umaga",
  afternoon: "hapon",
  evening: "gabi",
  night: "gabi"
};
const dayPeriodValues$4 = {
  narrow: {
    ...defaultDayPeriodValues$4,
    am: "A",
    pm: "P"
  },
  abbreviated: defaultDayPeriodValues$4,
  wide: defaultDayPeriodValues$4
};
function ordinalNumber(dirtyNumber) {
  const number = Number(dirtyNumber);
  return `ika-${number}`;
}
const localize$4 = {
  ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn$1({
    values: monthValues$4,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$4,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$4,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$3,
    defaultFormattingWidth: "wide"
  })
};
const filLocale = {
  code: "fil",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$4,
  formatRelative: formatRelative$1,
  localize: localize$4,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const dateFormats$3 = {
  full: "EEEE, d 'di' MMMM 'di' yyyy",
  long: "d 'di' MMMM 'di' yyyy",
  medium: "d 'di' MMM 'di' yyyy",
  short: "d/MM/yyyy"
};
const timeFormats$2 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$3 = {
  full: "{{date}} 'na' {{time}}",
  long: "{{date}} 'na' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$3 = {
  date: buildFormatLongFn({
    formats: dateFormats$3,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$3,
    defaultWidth: "full"
  })
};
const defaultMonthValues$3 = [
  "Janeru",
  "Fevereru",
  "Marsu",
  "Abril",
  "Maiu",
  "Junhu",
  "Julhu",
  "Agostu",
  "Sitenbru",
  "Otubru",
  "Novenbru",
  "Dizenbru"
];
const abbreviatedMonthValues = [
  "Jan.",
  "Fev.",
  "Marsu",
  "Abril",
  "Maiu",
  "Junhu",
  "Julhu",
  "Ago.",
  "Sit.",
  "Otu.",
  "Nov.",
  "Diz."
];
const monthValues$3 = {
  narrow: abbreviatedMonthValues,
  abbreviated: abbreviatedMonthValues,
  wide: defaultMonthValues$3
};
const defaultDayValues$3 = [
  "Dumingu",
  "Sigunda-fera",
  "Tersa-fera",
  "Kuarta-fera",
  "Kinta-fera",
  "Sesta-fera",
  "Sabadu"
];
const abbreviatedDayValues = ["Dum", "Sig", "Ter", "Kua", "Kin", "Ses", "Sab"];
const dayValues$3 = {
  narrow: abbreviatedDayValues,
  short: abbreviatedDayValues,
  abbreviated: abbreviatedDayValues,
  wide: defaultDayValues$3
};
const defaultDayPeriodValues$3 = {
  am: "di sedu",
  pm: "di tardi",
  midnight: "meia noti",
  noon: "meiu dia",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const abbreviatedDayPeriodValues = {
  ...defaultDayPeriodValues$3,
  am: "SEDU",
  pm: "TARDI"
};
const dayPeriodValues$3 = {
  narrow: abbreviatedDayPeriodValues,
  abbreviated: abbreviatedDayPeriodValues,
  wide: defaultDayPeriodValues$3
};
const defaultFormattingDayPeriodValues$2 = {
  am: "di sedu",
  pm: "di tardi",
  midnight: "meia noti",
  noon: "meiu dia",
  morning: "in the morning",
  afternoon: "in the afternoon",
  evening: "in the evening",
  night: "at night"
};
const abbreviatedFormattingDayPeriodValues = {
  ...defaultFormattingDayPeriodValues$2,
  am: "SEDU",
  pm: "TARDI"
};
const formattingDayPeriodValues$2 = {
  narrow: abbreviatedFormattingDayPeriodValues,
  abbreviated: abbreviatedFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues$2
};
const localize$3 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$3,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$3,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: "wide"
  })
};
const keaLocale = {
  code: "kea",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$3,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$3,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const dateFormats$2 = {
  full: "EEEE, d MMMM 'ឆ្នាំ' yyyy",
  long: "d MMMM 'ឆ្នាំ' yyyy",
  medium: "d MMM 'ឆ្នាំ' yyyy",
  short: "d/MM/yyyy"
};
const timeFormats$1 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$2 = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$2,
    defaultWidth: "full"
  })
};
const defaultMonthValues$2 = [
  "មករា",
  "កុម្ភៈ",
  "មីនា",
  "មេសា",
  "ឧសភា",
  "មិថុនា",
  "កក្កដា",
  "សីហា",
  "កញ្",
  "តុលា",
  "វិច្ឆិកា",
  "ធ្"
];
const monthValues$2 = {
  narrow: defaultMonthValues$2,
  abbreviated: defaultMonthValues$2,
  wide: defaultMonthValues$2
};
const defaultDayValues$2 = ["អាទិត្យ", "ច័ន្", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្", "សៅរ៍"];
const dayValues$2 = {
  narrow: defaultDayValues$2,
  short: defaultDayValues$2,
  abbreviated: defaultDayValues$2,
  wide: defaultDayValues$2
};
const defaultDayPeriodValues$2 = {
  am: "ព្រឹក",
  pm: "រសៀល",
  midnight: "mi",
  noon: "n",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const dayPeriodValues$2 = {
  narrow: defaultDayPeriodValues$2,
  abbreviated: defaultDayPeriodValues$2,
  wide: defaultDayPeriodValues$2
};
const defaultFormattingDayPeriodValues$1 = {
  am: "ព្រឹក",
  pm: "រសៀល",
  midnight: "mi",
  noon: "n",
  morning: "in the morning",
  afternoon: "in the afternoon",
  evening: "in the evening",
  night: "at night"
};
const formattingDayPeriodValues$1 = {
  narrow: defaultFormattingDayPeriodValues$1,
  abbreviated: defaultFormattingDayPeriodValues$1,
  wide: defaultFormattingDayPeriodValues$1
};
const localize$2 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$2,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$2,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$2,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
const kmLocale = {
  code: "km",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$2,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$2,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
const dateFormats$1 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/MM/yyyy"
};
const timeFormats = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
const dateTimeFormats$1 = {
  full: "{{date}} 'markay saacadu tahay:' {{time}}",
  long: "{{date}} 'markay saacadu tahay:' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
const defaultMonthValues$1 = [
  "Janaayo",
  "Febaraayo",
  "Maarso",
  "Abriil",
  "Maayo",
  "Juun",
  "Luuliyo",
  "Agoosto",
  "Sibteembar",
  "Oktoobar",
  "Nufeembar",
  "Diseembar"
];
const monthValues$1 = {
  narrow: defaultMonthValues$1,
  abbreviated: defaultMonthValues$1,
  wide: defaultMonthValues$1
};
const defaultDayValues$1 = ["Axad", "Isniin", "Talaado", "Arbaco", "Khamiis", "Jimce", "Sabti"];
const dayValues$1 = {
  narrow: defaultDayValues$1,
  short: defaultDayValues$1,
  abbreviated: defaultDayValues$1,
  wide: defaultDayValues$1
};
const defaultDayPeriodValues$1 = {
  am: "galinka hore",
  pm: "galinka danbe",
  midnight: "saqdhexe",
  noon: "duhurkii",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const dayPeriodValues$1 = {
  narrow: defaultDayPeriodValues$1,
  abbreviated: defaultDayPeriodValues$1,
  wide: defaultDayPeriodValues$1
};
const defaultFormattingDayPeriodValues = {
  am: "galinka hore",
  pm: "galinka danbe",
  midnight: "saqdhexe",
  noon: "duhurkii",
  morning: "in the morning",
  afternoon: "in the afternoon",
  evening: "in the evening",
  night: "at night"
};
const formattingDayPeriodValues = {
  narrow: defaultFormattingDayPeriodValues,
  abbreviated: defaultFormattingDayPeriodValues,
  wide: defaultFormattingDayPeriodValues
};
const localize$1 = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: enUsLocale.localize.era,
  quarter: enUsLocale.localize.quarter,
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const soLocale = {
  code: "som",
  formatDistance: enUsLocale.formatDistance,
  formatLong: formatLong$1,
  formatRelative: enUsLocale.formatRelative,
  localize: localize$1,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
const dateFormats = {
  full: "EEEE، MMMM d، y",
  long: "MMMM d، y",
  medium: "MMM d، y",
  short: "d/M/yy"
};
const dateTimeFormats = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: enUsLocale.formatLong.time,
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'گزشتہ' eeee p 'بعد دوپہر'",
  yesterday: "'گزشتہ کل' p 'بعد دوپہر'",
  today: "'آج' p 'بعد دوپہر'",
  tomorrow: "'آئندہ کل' p 'بعد دوپہر'",
  nextWeek: "'اگلے' eeee p 'بعد دوپہر'",
  other: "P"
};
const formatRelative = (token) => formatRelativeLocale[token];
const defaultEraValues = ["قبل مسیح", "عیسوی"];
const eraValues = {
  narrow: defaultEraValues,
  abbreviated: defaultEraValues,
  wide: defaultEraValues
};
const defaultMonthValues = [
  "جنوری",
  "فروری",
  "مارچ",
  "اپریل",
  "مئی",
  "جون",
  "جولائی",
  "اگست",
  "ستمبر",
  "اکتوبر",
  "نومبر",
  "دسمبر"
];
const narrowMonthValues = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
const monthValues = {
  narrow: narrowMonthValues,
  abbreviated: defaultMonthValues,
  wide: defaultMonthValues
};
const defaultDayValues = ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];
const dayValues = {
  narrow: defaultDayValues,
  short: defaultDayValues,
  abbreviated: defaultDayValues,
  wide: defaultDayValues
};
const defaultDayPeriodValues = {
  am: "AM",
  pm: "PM",
  midnight: "آدھی رات",
  morning: "صبح",
  afternoon: "دوپہر",
  evening: "ማታ",
  night: "رات"
};
const dayPeriodValues = {
  narrow: defaultDayPeriodValues,
  abbreviated: defaultDayPeriodValues,
  wide: defaultDayPeriodValues
};
const defaultQuarterValues = ["پہلی سہ ماہی", "دوسری سہ ماہی", "تیسری سہ ماہی", "چوتهی سہ ماہی"];
const narrowQuarterValues = ["1", "2", "3", "4"];
const quarterValues = {
  narrow: narrowQuarterValues,
  abbreviated: defaultQuarterValues,
  wide: defaultQuarterValues
};
const localize = {
  ordinalNumber: enUsLocale.localize.ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    formattingValues: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: dayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const urLocale = {
  code: "ur",
  formatDistance: enUsLocale.formatDistance,
  formatLong,
  formatRelative,
  localize,
  match: enUsLocale.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var Locale = /* @__PURE__ */ ((Locale2) => {
  Locale2["ENGLISH"] = "en-US";
  Locale2["SPANISH"] = "es-US";
  Locale2["CHINESE_SIMPLIFIED"] = "zh-CN";
  Locale2["CHINESE_TRADITIONAL"] = "zh-hant";
  Locale2["PORTUGUESE"] = "pt-PT";
  Locale2["HAITIAN_CREOLE"] = "ht";
  Locale2["KOREAN"] = "ko";
  Locale2["RUSSIAN"] = "ru-RU";
  Locale2["VIETNAMESE"] = "vi";
  Locale2["ARABIC"] = "ar-SA";
  Locale2["FILIPINO"] = "fil";
  Locale2["SAMOAN"] = "sm";
  Locale2["KHMER"] = "km";
  Locale2["POLISH"] = "pl";
  Locale2["UKRAINIAN"] = "uk";
  Locale2["URDU"] = "ur";
  Locale2["FRENCH"] = "fr";
  Locale2["SOMALI"] = "so";
  Locale2["FARSI"] = "fa";
  Locale2["CAPE_VERDEAN_CREOLE"] = "kea";
  Locale2["AMHARIC"] = "am";
  Locale2["MARSHALLESE"] = "mh";
  Locale2["HMONG"] = "hmn";
  Locale2["HINDI"] = "hi";
  Locale2["HUNGARIAN"] = "hu";
  Locale2["DUTCH"] = "nl";
  return Locale2;
})(Locale || {});
const ALL_LOCALES = Object.values(Locale);
const RIGHT_TO_LEFT_LOCALES = /* @__PURE__ */ new Set();
RIGHT_TO_LEFT_LOCALES.add(
  "ar-SA"
  /* ARABIC */
);
RIGHT_TO_LEFT_LOCALES.add(
  "ur"
  /* URDU */
);
RIGHT_TO_LEFT_LOCALES.add(
  "fa"
  /* FARSI */
);
const DEFAULT_LOCALE = "en-US";
var ExtraLocale = /* @__PURE__ */ ((ExtraLocale2) => {
  ExtraLocale2["AMERICAN_SIGN_LANGUAGE"] = "ase";
  return ExtraLocale2;
})(ExtraLocale || {});
const MOMENT_LOCALE_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "en",
  [
    "es-US"
    /* SPANISH */
  ]: "es",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "zh-cn",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "pt",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "ht",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "ru",
  [
    "vi"
    /* VIETNAMESE */
  ]: "vi",
  [
    "ar-SA"
    /* ARABIC */
  ]: "ar",
  [
    "fil"
    /* FILIPINO */
  ]: "tl-ph",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "zh-tw",
  [
    "km"
    /* KHMER */
  ]: "km",
  [
    "pl"
    /* POLISH */
  ]: "pl",
  [
    "uk"
    /* UKRAINIAN */
  ]: "uk",
  [
    "ur"
    /* URDU */
  ]: "ur",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "fa"
    /* FARSI */
  ]: "fa",
  [
    "hi"
    /* HINDI */
  ]: "hi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "hu",
  [
    "nl"
    /* DUTCH */
  ]: "nl",
  // locales not supported in moment
  [
    "sm"
    /* SAMOAN */
  ]: "en",
  [
    "so"
    /* SOMALI */
  ]: "en",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "en",
  [
    "am"
    /* AMHARIC */
  ]: "en",
  [
    "mh"
    /* MARSHALLESE */
  ]: "en",
  [
    "hmn"
    /* HMONG */
  ]: "en"
};
const DATE_FNS_LOCALES = {
  [
    "en-US"
    /* ENGLISH */
  ]: enUsLocale,
  [
    "es-US"
    /* SPANISH */
  ]: esLocale,
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: zhCnLocale,
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: ptLocale,
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: htLocale,
  [
    "ko"
    /* KOREAN */
  ]: koLocale,
  [
    "ru-RU"
    /* RUSSIAN */
  ]: ruLocale,
  [
    "vi"
    /* VIETNAMESE */
  ]: viLocale,
  [
    "ar-SA"
    /* ARABIC */
  ]: arLocale,
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: zhTwLocale,
  [
    "pl"
    /* POLISH */
  ]: plLocale,
  [
    "uk"
    /* UKRAINIAN */
  ]: ukLocale,
  [
    "fr"
    /* FRENCH */
  ]: frLocale,
  [
    "fa"
    /* FARSI */
  ]: faIrLocale,
  [
    "hi"
    /* HINDI */
  ]: hiLocale,
  [
    "hu"
    /* HUNGARIAN */
  ]: huLocale,
  [
    "nl"
    /* DUTCH */
  ]: nlLocale,
  // locales not yet supported in date-fns
  [
    "sm"
    /* SAMOAN */
  ]: enUsLocale,
  [
    "mh"
    /* MARSHALLESE */
  ]: enUsLocale,
  [
    "hmn"
    /* HMONG */
  ]: enUsLocale,
  // locales not yet supported in date-fns with custom overrides
  [
    "fil"
    /* FILIPINO */
  ]: filLocale,
  [
    "km"
    /* KHMER */
  ]: kmLocale,
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: keaLocale,
  [
    "so"
    /* SOMALI */
  ]: soLocale,
  [
    "am"
    /* AMHARIC */
  ]: amLocale,
  [
    "ur"
    /* URDU */
  ]: urLocale
};
const LOCALE_DISPLAY_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "English",
  [
    "es-US"
    /* SPANISH */
  ]: "Español",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "简体中文",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "Português",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "Kreyòl Ayisyen",
  [
    "ko"
    /* KOREAN */
  ]: "한국어",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "русский",
  [
    "vi"
    /* VIETNAMESE */
  ]: "Tiếng Việt",
  [
    "ar-SA"
    /* ARABIC */
  ]: "العربية",
  [
    "fil"
    /* FILIPINO */
  ]: "Filipino",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "繁體中文",
  [
    "sm"
    /* SAMOAN */
  ]: "Gagana fa'a Samoa",
  [
    "km"
    /* KHMER */
  ]: "ខ្មែរ",
  [
    "pl"
    /* POLISH */
  ]: "Polski",
  [
    "uk"
    /* UKRAINIAN */
  ]: "українська",
  [
    "ur"
    /* URDU */
  ]: "اُردُو",
  [
    "fr"
    /* FRENCH */
  ]: "Français",
  [
    "fa"
    /* FARSI */
  ]: "فارسی",
  [
    "so"
    /* SOMALI */
  ]: "Soomaali",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "Kriolu",
  [
    "am"
    /* AMHARIC */
  ]: "አማርኛ",
  [
    "mh"
    /* MARSHALLESE */
  ]: "kajin Majöl",
  [
    "hi"
    /* HINDI */
  ]: "हिन्दी",
  [
    "hmn"
    /* HMONG */
  ]: "Hmoob",
  [
    "ase"
    /* AMERICAN_SIGN_LANGUAGE */
  ]: "American Sign Language (ASL)",
  [
    "hu"
    /* HUNGARIAN */
  ]: "Magyar",
  [
    "nl"
    /* DUTCH */
  ]: "Nederlands"
};
const SHORT_LOCALE_DISPLAY_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "EN",
  [
    "es-US"
    /* SPANISH */
  ]: "ES",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "简体中文",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "PT",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "HT",
  [
    "ko"
    /* KOREAN */
  ]: "한국어",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "RU",
  [
    "vi"
    /* VIETNAMESE */
  ]: "VI",
  [
    "ar-SA"
    /* ARABIC */
  ]: "AR",
  [
    "fil"
    /* FILIPINO */
  ]: "KWF",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "繁體中文",
  [
    "sm"
    /* SAMOAN */
  ]: "SM",
  [
    "km"
    /* KHMER */
  ]: "KM",
  [
    "pl"
    /* POLISH */
  ]: "PL",
  [
    "uk"
    /* UKRAINIAN */
  ]: "UK",
  [
    "ur"
    /* URDU */
  ]: "UR",
  [
    "fr"
    /* FRENCH */
  ]: "FR",
  [
    "fa"
    /* FARSI */
  ]: "FA",
  [
    "so"
    /* SOMALI */
  ]: "SO",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "KEA",
  [
    "am"
    /* AMHARIC */
  ]: "AM",
  [
    "mh"
    /* MARSHALLESE */
  ]: "MH",
  [
    "hmn"
    /* HMONG */
  ]: "HMN",
  [
    "hi"
    /* HINDI */
  ]: "HI",
  [
    "hu"
    /* HUNGARIAN */
  ]: "HU",
  [
    "nl"
    /* DUTCH */
  ]: "NL"
};
const LOCALE_ENGLISH_NAMES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "English",
  [
    "es-US"
    /* SPANISH */
  ]: "Spanish",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "Simplified Chinese",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "Portuguese",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "Haitian Creole",
  [
    "ko"
    /* KOREAN */
  ]: "Korean",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "Russian",
  [
    "vi"
    /* VIETNAMESE */
  ]: "Vietnamese",
  [
    "ar-SA"
    /* ARABIC */
  ]: "Arabic",
  [
    "fil"
    /* FILIPINO */
  ]: "Filipino",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "Traditional Chinese",
  [
    "sm"
    /* SAMOAN */
  ]: "Samoan",
  [
    "km"
    /* KHMER */
  ]: "Khmer",
  [
    "pl"
    /* POLISH */
  ]: "Polish",
  [
    "uk"
    /* UKRAINIAN */
  ]: "Ukrainian",
  [
    "ur"
    /* URDU */
  ]: "Urdu",
  [
    "fr"
    /* FRENCH */
  ]: "French",
  [
    "fa"
    /* FARSI */
  ]: "Farsi",
  [
    "so"
    /* SOMALI */
  ]: "Somali",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "Cape Verdean Creole",
  [
    "am"
    /* AMHARIC */
  ]: "Amharic",
  [
    "mh"
    /* MARSHALLESE */
  ]: "Marshallese",
  [
    "hmn"
    /* HMONG */
  ]: "Hmong",
  [
    "hi"
    /* HINDI */
  ]: "Hindi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "Hungarian",
  [
    "nl"
    /* DUTCH */
  ]: "Dutch"
};
const FRONTEND_TO_DJANGO_LOCALES = {
  [
    "en-US"
    /* ENGLISH */
  ]: "en",
  [
    "es-US"
    /* SPANISH */
  ]: "es",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "zh-hans",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "pt",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "ht",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "ru",
  [
    "vi"
    /* VIETNAMESE */
  ]: "vi",
  [
    "ar-SA"
    /* ARABIC */
  ]: "ar",
  [
    "fil"
    /* FILIPINO */
  ]: "fil",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "zh-hant",
  [
    "sm"
    /* SAMOAN */
  ]: "sm",
  [
    "km"
    /* KHMER */
  ]: "km",
  [
    "pl"
    /* POLISH */
  ]: "po",
  [
    "uk"
    /* UKRAINIAN */
  ]: "uk",
  [
    "ur"
    /* URDU */
  ]: "ur",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "fa"
    /* FARSI */
  ]: "fa",
  [
    "so"
    /* SOMALI */
  ]: "so",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "kea",
  [
    "am"
    /* AMHARIC */
  ]: "am",
  [
    "mh"
    /* MARSHALLESE */
  ]: "mh",
  [
    "hmn"
    /* HMONG */
  ]: "hmn",
  [
    "hi"
    /* HINDI */
  ]: "hi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "hu",
  [
    "nl"
    /* DUTCH */
  ]: "nl"
};
const DJANGO_TO_FRONTEND_LOCALES = Object.fromEntries(
  Object.entries(FRONTEND_TO_DJANGO_LOCALES).map(([frontendLocale, djangoLocale]) => [djangoLocale, frontendLocale])
);
var ColorIso639Code = /* @__PURE__ */ ((ColorIso639Code2) => {
  ColorIso639Code2["ENGLISH"] = "en";
  ColorIso639Code2["SPANISH"] = "es";
  ColorIso639Code2["CHINESE_SIMPLIFIED"] = "zh_Hans";
  ColorIso639Code2["CHINESE_TRADITIONAL"] = "zh_Hant";
  ColorIso639Code2["PORTUGUESE"] = "pt";
  ColorIso639Code2["HAITIAN_CREOLE"] = "ht";
  ColorIso639Code2["KOREAN"] = "ko";
  ColorIso639Code2["RUSSIAN"] = "ru";
  ColorIso639Code2["VIETNAMESE"] = "vi";
  ColorIso639Code2["ARABIC"] = "ar";
  ColorIso639Code2["FILIPINO"] = "fil";
  ColorIso639Code2["SAMOAN"] = "sm";
  ColorIso639Code2["KHMER"] = "km";
  ColorIso639Code2["POLISH"] = "pl";
  ColorIso639Code2["UKRAINIAN"] = "uk";
  ColorIso639Code2["URDU"] = "ur";
  ColorIso639Code2["FRENCH"] = "fr";
  ColorIso639Code2["SOMALI"] = "so";
  ColorIso639Code2["FARSI"] = "fa";
  ColorIso639Code2["CAPE_VERDEAN_CREOLE"] = "kea";
  ColorIso639Code2["AMHARIC"] = "am";
  ColorIso639Code2["MARSHALLESE"] = "mh";
  ColorIso639Code2["HMONG"] = "hmn";
  ColorIso639Code2["HINDI"] = "hi";
  ColorIso639Code2["HUNGARIAN"] = "hu";
  ColorIso639Code2["DUTCH"] = "nl";
  return ColorIso639Code2;
})(ColorIso639Code || {});
const COLOR_ISO_639_CODE_BY_LOCALE = {
  [
    "en-US"
    /* ENGLISH */
  ]: "en",
  [
    "es-US"
    /* SPANISH */
  ]: "es",
  [
    "zh-CN"
    /* CHINESE_SIMPLIFIED */
  ]: "zh_Hans",
  [
    "zh-hant"
    /* CHINESE_TRADITIONAL */
  ]: "zh_Hant",
  [
    "pt-PT"
    /* PORTUGUESE */
  ]: "pt",
  [
    "ht"
    /* HAITIAN_CREOLE */
  ]: "ht",
  [
    "ko"
    /* KOREAN */
  ]: "ko",
  [
    "ru-RU"
    /* RUSSIAN */
  ]: "ru",
  [
    "vi"
    /* VIETNAMESE */
  ]: "vi",
  [
    "ar-SA"
    /* ARABIC */
  ]: "ar",
  [
    "fil"
    /* FILIPINO */
  ]: "fil",
  [
    "sm"
    /* SAMOAN */
  ]: "sm",
  [
    "km"
    /* KHMER */
  ]: "km",
  [
    "pl"
    /* POLISH */
  ]: "pl",
  [
    "uk"
    /* UKRAINIAN */
  ]: "uk",
  [
    "ur"
    /* URDU */
  ]: "ur",
  [
    "fr"
    /* FRENCH */
  ]: "fr",
  [
    "so"
    /* SOMALI */
  ]: "so",
  [
    "fa"
    /* FARSI */
  ]: "fa",
  [
    "kea"
    /* CAPE_VERDEAN_CREOLE */
  ]: "kea",
  [
    "am"
    /* AMHARIC */
  ]: "am",
  [
    "mh"
    /* MARSHALLESE */
  ]: "mh",
  [
    "hmn"
    /* HMONG */
  ]: "hmn",
  [
    "hi"
    /* HINDI */
  ]: "hi",
  [
    "hu"
    /* HUNGARIAN */
  ]: "hu",
  [
    "nl"
    /* DUTCH */
  ]: "nl"
  /* DUTCH */
};
const globalCookies = new Cookies();
const setGlobalCookie = globalCookies.set.bind(globalCookies);
const removeGlobalCookie = globalCookies.remove.bind(globalCookies);
function useCookies() {
  const [cookies, setCookies] = useState(globalCookies.getAll());
  useLayoutEffect(() => {
    function onChange() {
      const newCookies = globalCookies.getAll();
      setCookies(newCookies);
    }
    globalCookies.addChangeListener(onChange);
    return () => {
      globalCookies.removeChangeListener(onChange);
    };
  }, []);
  return {
    setCookie: setGlobalCookie,
    removeCookie: removeGlobalCookie,
    cookies
  };
}
const [CookiesProvider, useCookiesContext] = constate(useCookies);
const PREFERRED_LOCALE_COOKIE_NAME = "preferredLocale";
function getValidLocale(locale) {
  if (locale.startsWith("en")) {
    return Locale.ENGLISH;
  }
  if (locale.startsWith("es")) {
    return Locale.SPANISH;
  }
  if (locale.startsWith("zh-CN")) {
    return Locale.CHINESE_SIMPLIFIED;
  }
  if (locale.startsWith("pt")) {
    return Locale.PORTUGUESE;
  }
  if (locale.startsWith("ht")) {
    return Locale.HAITIAN_CREOLE;
  }
  if (locale.startsWith("ko")) {
    return Locale.KOREAN;
  }
  if (locale.startsWith("ru")) {
    return Locale.RUSSIAN;
  }
  if (locale.startsWith("vi")) {
    return Locale.VIETNAMESE;
  }
  if (locale.startsWith("ar")) {
    return Locale.ARABIC;
  }
  if (locale.startsWith("fil")) {
    return Locale.FILIPINO;
  }
  if (locale.startsWith("zh-hant")) {
    return Locale.CHINESE_TRADITIONAL;
  }
  if (locale.startsWith("sm")) {
    return Locale.SAMOAN;
  }
  if (locale.startsWith("km")) {
    return Locale.KHMER;
  }
  if (locale.startsWith("pl")) {
    return Locale.POLISH;
  }
  if (locale.startsWith("uk")) {
    return Locale.UKRAINIAN;
  }
  if (locale.startsWith("ur")) {
    return Locale.URDU;
  }
  if (locale.startsWith("kea")) {
    return Locale.CAPE_VERDEAN_CREOLE;
  }
  if (locale.startsWith("fa")) {
    return Locale.FARSI;
  }
  if (locale.startsWith("fr")) {
    return Locale.FRENCH;
  }
  if (locale.startsWith("so")) {
    return Locale.SOMALI;
  }
  if (locale.startsWith("am")) {
    return Locale.AMHARIC;
  }
  if (locale.startsWith("mh")) {
    return Locale.MARSHALLESE;
  }
  if (locale.startsWith("hmn")) {
    return Locale.HMONG;
  }
  if (locale.startsWith("hi")) {
    return Locale.HINDI;
  }
  if (locale.startsWith("hu")) {
    return Locale.HUNGARIAN;
  }
  if (locale.startsWith("nl")) {
    return Locale.DUTCH;
  }
  return null;
}
function setDocumentLangAttribute(validLocale) {
  document.documentElement.setAttribute("lang", validLocale);
}
function getCurrentLocaleFromCookies(cookies) {
  const cookieValue = cookies[PREFERRED_LOCALE_COOKIE_NAME];
  return getValidLocale(cookieValue || navigator.language) || DEFAULT_LOCALE;
}
function usePreferredLocale() {
  const { cookies, setCookie } = useCookiesContext();
  const locale = getCurrentLocaleFromCookies(cookies);
  useEffect(() => {
    setDocumentLangAttribute(locale);
  }, [locale]);
  const setLocale = useCallback(
    (newLocale) => {
      setCookie(PREFERRED_LOCALE_COOKIE_NAME, newLocale, { path: "/" });
    },
    [setCookie]
  );
  const localeIsRightToLeft = useMemo(() => RIGHT_TO_LEFT_LOCALES.has(locale), [locale]);
  return {
    locale,
    setLocale,
    localeIsRightToLeft
  };
}
function useDateFnsLocale() {
  const { locale } = usePreferredLocale();
  return DATE_FNS_LOCALES[locale];
}
function useUrlQueryParam(paramKey, defaultValue = "") {
  const { search } = useLocation();
  const history = useHistory();
  const rawQueryParam = getQueryParam(search, paramKey);
  const setQueryParam = useCallback(
    (value) => {
      const newSearch = mergeQueryParam(search, paramKey, value);
      history.replace({ search: newSearch });
    },
    [search, paramKey, history]
  );
  const removeQueryParam = useCallback(() => {
    const newSearch = stripQueryParam(search, paramKey);
    history.replace({ search: newSearch });
  }, [search, paramKey, history]);
  const queryParam = rawQueryParam || defaultValue;
  return { queryParam, setQueryParam, removeQueryParam };
}
function useUrlQueryParams(defaultValues) {
  const { search } = useLocation();
  const history = useHistory();
  const setQueryParams = useCallback(
    (paramValues) => {
      const newParams = pickBy(paramValues, identity);
      const newSearch = toQueryString(newParams);
      history.replace({ search: newSearch });
    },
    [history]
  );
  const queryParams = useMemo(() => {
    const params = {};
    Object.keys(defaultValues).forEach((key) => {
      const urlQueryValue = getQueryParam(search, key);
      params[key] = urlQueryValue ?? defaultValues[key];
    });
    return params;
  }, [defaultValues, search]);
  return { queryParams, setQueryParams };
}
function useQueryParamLocale() {
  const { locale, setLocale } = usePreferredLocale();
  const { queryParam, removeQueryParam } = useUrlQueryParam("locale");
  useEffect(() => {
    if (queryParam) {
      removeQueryParam();
      const validLocale = getValidLocale(queryParam);
      if (validLocale && locale !== validLocale) {
        setLocale(validLocale);
      }
    }
  }, [locale, queryParam, removeQueryParam, setLocale]);
}
const sortLocales = (locales) => {
  return locales.sort((locale1, locale2) => {
    const shortLocaleName1 = MOMENT_LOCALE_NAMES[locale1];
    const shortLocaleName2 = MOMENT_LOCALE_NAMES[locale2];
    return shortLocaleName1.localeCompare(shortLocaleName2);
  });
};
function setMockPreferredLocale(locale = DEFAULT_LOCALE) {
  Object.defineProperty(window.document, "cookie", {
    writable: true,
    value: `${PREFERRED_LOCALE_COOKIE_NAME}=${locale}`
  });
}
function isDefined(arg) {
  return arg != null;
}
function getMarketingUrl(path = "") {
  const pathWithPrefix = path.startsWith("/") ? path : `/${path}`;
  if (isEnvironmentLocal()) {
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
  }
  if (isEnvironmentStaging()) {
    return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
  }
  if (isEnvironmentProduction()) {
    return `https://www.color.com${pathWithPrefix}`;
  }
  return `https://test-color-genomics.pantheonsite.io${pathWithPrefix}`;
}
function withDefaultProps(Component, defaultProps) {
  return (props) => /* @__PURE__ */ jsx(Component, { ...defaultProps, ...props });
}
const createMswGetHandler = (endpoint, options) => {
  const { statusCode = 200, response = {} } = options || {};
  return http.get(endpoint, () => {
    return new Response(response ? JSON.stringify(response) : null, {
      status: statusCode,
      headers: {
        "Content-Type": "application/json"
      }
    });
  });
};
const createMswPostHandler = (endpoint, options) => {
  const { statusCode = 200, response = {} } = options || {};
  return http.post(endpoint, () => {
    return new Response(response ? JSON.stringify(response) : null, {
      status: statusCode,
      headers: {
        "Content-Type": "application/json"
      }
    });
  });
};
const createMswPostHandlerSpy = (endpoint, options) => {
  const { statusCode = 200, response = {} } = options || {};
  let postedValues;
  let wasCalled = false;
  const handler = http.post(endpoint, async ({ request }) => {
    try {
      postedValues = await request.json();
    } catch {
    } finally {
      wasCalled = true;
    }
    return new Response(response ? JSON.stringify(response) : null, {
      status: statusCode,
      headers: {
        "Content-Type": "application/json"
      }
    });
  });
  return {
    getPostedValues: () => postedValues,
    getWasCalled: () => wasCalled,
    handler
  };
};
const createMswPatchHandler = (endpoint, options) => {
  const { statusCode = 200, response = {} } = options || {};
  return http.patch(endpoint, () => {
    return new Response(response ? JSON.stringify(response) : null, {
      status: statusCode,
      headers: {
        "Content-Type": "application/json"
      }
    });
  });
};
const useAnalytics = () => {
  const referrerRef = useReferrerContext();
  const { locale } = usePreferredLocale();
  const dangerouslyLogPageViewAnalytics = useCallback(
    (name, properties) => {
      const referrer = referrerRef.current;
      logAnalyticsPageView(name, {
        preferred_locale: locale,
        ...pickBy(properties, (value) => isDefined(value)),
        referrer
      });
    },
    [referrerRef, locale]
  );
  return {
    dangerouslyLogPageViewAnalytics
  };
};
function useLogPageViewUsingUniqueId(props) {
  const { pathname } = useLocation();
  const { loggingIsEnabled = true, uniquePageId = pathname, pageName, properties } = props;
  const { dangerouslyLogPageViewAnalytics } = useAnalytics();
  const lastLoggedUniquePageIdRef = useRef("");
  useEffect(() => {
    if (loggingIsEnabled && uniquePageId && pageName && lastLoggedUniquePageIdRef.current !== uniquePageId) {
      lastLoggedUniquePageIdRef.current = uniquePageId;
      dangerouslyLogPageViewAnalytics(pageName, properties);
    }
  }, [loggingIsEnabled, dangerouslyLogPageViewAnalytics, pageName, properties, uniquePageId]);
}
function useIdentifyAnalyticsUser(userProps) {
  useEffect(() => {
    if (userProps) {
      identifyAnalyticsUser(userProps);
    }
  }, [userProps]);
}
function isInstanceOfIErrorPayload(object) {
  return typeof object === "object" && object !== null && "status" in object && "message" in object;
}
const defaultOptions = {
  queries: {
    queryFn({ queryKey }) {
      const [endpoint, options] = queryKey;
      const { searchParams } = options ?? {};
      return ApiClient.get(endpoint, {
        params: searchParams ?? options
      });
    },
    retry(failureCount, error) {
      return isInstanceOfIErrorPayload(error) && error.status === 500 && failureCount < 3;
    },
    refetchOnWindowFocus: false
  }
};
const reactQueryClient = new QueryClient({
  defaultOptions
});
const createFakeReactQueryClient = (responseConfigs) => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        queryFn(query) {
          const { queryKey } = query;
          const endpoint = queryKey[0];
          const additionalQueryKey = queryKey[1];
          const matchedConfig = responseConfigs.find(
            (config) => config.endpoint === endpoint && isEqual(config.additionalQueryKey, additionalQueryKey)
          );
          if (matchedConfig) {
            const { response } = matchedConfig;
            const responseObject = response instanceof Function ? response() : response;
            if (responseObject instanceof Error) {
              throw responseObject;
            }
            return responseObject;
          }
          throw new Error(`Unknown query ${JSON.stringify(queryKey)}`);
        },
        retry() {
          return false;
        }
      }
    }
  });
};
var PopulationRelationship = /* @__PURE__ */ ((PopulationRelationship2) => {
  PopulationRelationship2["EMPLOYEE"] = "employee";
  PopulationRelationship2["HEALTH_INSURANCE_BENEFICIARY"] = "health_insurance_beneficiary";
  PopulationRelationship2["NON_HEALTH_INSURANCE_BENEFICIARY"] = "non_health_insurance_beneficiary";
  return PopulationRelationship2;
})(PopulationRelationship || {});
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["USER_WITH_ACCOUNT"] = "user_with_account";
  UserRole2["NO_TEST"] = "no_test";
  UserRole2["GENETICS"] = "genetics";
  UserRole2["COVID_NON_DEPENDENT_PROXY"] = "covid_proxy";
  UserRole2["COVID_FULL_USER_OR_DEPENDENT"] = "covid_full_user_or_dependent";
  UserRole2["CARE_FULL_USER_OR_DEPENDENT"] = "care_full_user_or_dependent";
  UserRole2["ESSENTIAL_CARE_USER"] = "essential_care_user";
  UserRole2["STI_TEST_USER"] = "sti_test_user";
  UserRole2["COLLECTION_SITE_ADMIN"] = "collection_site_admin";
  UserRole2["COVID_SITE_MANAGER"] = "covid_site_manager";
  UserRole2["PROVIDER"] = "provider";
  UserRole2["SUPPORT_STAFF"] = "support_staff";
  UserRole2["COLOR_EMPLOYEE"] = "color_employee";
  UserRole2["DASHBOARD_VIEWER"] = "dashboard_viewer";
  UserRole2["ACCESS_MANAGER"] = "access_manager";
  UserRole2["SUPPORT_ADMIN"] = "support_admin";
  UserRole2["ELIGIBILITY_DATA_MANAGER"] = "eligibility_data_manager";
  UserRole2["SAMPLE_REVIEWER"] = "sample_reviewer";
  UserRole2["ORDERING_PHYSICIAN"] = "ordering_physician";
  UserRole2["GENETIC_COUNSELOR"] = "genetic_counselor";
  UserRole2["EXTERNAL_CLASSIFICATION_REVIEWER"] = "external_classification_reviewer";
  UserRole2["VARIANT_REVIEWER"] = "variant_reviewer";
  UserRole2["VARIANT_REVIEWER_MANAGER"] = "variant_reviewer_manager";
  UserRole2["GENETICS_BOARD_MEMBER"] = "genetics_board_member";
  UserRole2["PATHOLOGIST"] = "pathologist";
  UserRole2["FULFILLMENT_STAFF"] = "fulfillment_staff";
  UserRole2["CONTACT_MANAGER"] = "contact_manager";
  UserRole2["VACCINATION_PLATFORM_SITE_MANAGER"] = "vaccination_platform_site_manager";
  UserRole2["VACCINATION_PLATFORM_STAFF_MANAGER"] = "vaccination_platform_staff_manager";
  UserRole2["VACCINATION_PLATFORM_SUPER_ADMIN"] = "vaccination_platform_super_admin";
  UserRole2["VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER"] = "vaccination_platform_site_inventory_manager";
  UserRole2["VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER"] = "vaccination_platform_bulk_inventory_manager";
  UserRole2["VACCINATION_PLATFORM_SITE_STAFF"] = "vaccination_platform_site_staff";
  UserRole2["VACCINATION_PLATFORM_SCRIBE"] = "vaccination_platform_scribe";
  UserRole2["VACCINATION_PLATFORM_VACCINATING_CLINICIAN"] = "vaccination_platform_vaccinating_clinician";
  return UserRole2;
})(UserRole || {});
const ALL_USER_ROLES = [
  "no_test",
  "genetics",
  "covid_proxy",
  "care_full_user_or_dependent",
  "covid_full_user_or_dependent",
  "essential_care_user",
  "sti_test_user",
  "covid_site_manager",
  "provider",
  "support_staff",
  "color_employee",
  "dashboard_viewer",
  "access_manager",
  "eligibility_data_manager",
  "collection_site_admin",
  "fulfillment_staff",
  "contact_manager",
  "vaccination_platform_site_manager",
  "vaccination_platform_staff_manager",
  "vaccination_platform_super_admin"
  /* VACCINATION_PLATFORM_SUPER_ADMIN */
];
const GENETICS_USER_ROLES = [
  "genetics",
  "no_test"
  /* NO_TEST */
];
var CollectionSiteRole = /* @__PURE__ */ ((CollectionSiteRole2) => {
  CollectionSiteRole2["ONSITE_STAFF"] = "sample_collection_admin";
  CollectionSiteRole2["BATCH_SHIPMENT_ADMIN"] = "batch_shipment_admin";
  CollectionSiteRole2["SITE_SCHEDULER"] = "site_scheduler";
  CollectionSiteRole2["SITE_MANAGER"] = "site_manager";
  CollectionSiteRole2["STAFF_MANAGER"] = "staff_manager";
  CollectionSiteRole2["VACCINE_INVENTORY_MANAGER"] = "vaccine_inventory_manager";
  CollectionSiteRole2["VACCINE_CLINICIAN"] = "vaccine_clinician";
  CollectionSiteRole2["SCRIBE"] = "scribe";
  return CollectionSiteRole2;
})(CollectionSiteRole || {});
var CollectionSiteRoleCategory = /* @__PURE__ */ ((CollectionSiteRoleCategory2) => {
  CollectionSiteRoleCategory2["GENERAL"] = "general";
  CollectionSiteRoleCategory2["APPOINTMENT_MANAGEMENT"] = "appointment_management";
  CollectionSiteRoleCategory2["INVENTORY_MANAGEMENT"] = "inventory_management";
  CollectionSiteRoleCategory2["ONSITE_PATIENT_MANAGEMENT"] = "onsite_patient_management";
  CollectionSiteRoleCategory2["BATCH_SHIPMENT"] = "batch_shipment";
  return CollectionSiteRoleCategory2;
})(CollectionSiteRoleCategory || {});
var UserPermission = /* @__PURE__ */ ((UserPermission2) => {
  UserPermission2["PUT_SAMPLES_ON_HOLD"] = "samples.put_sample_on_hold";
  UserPermission2["VIEW_USERS"] = "users.view_users";
  UserPermission2["VIEW_PHI"] = "users.view_phi";
  UserPermission2["VIEW_APPOINTMENTS"] = "counseling.view_appointments";
  UserPermission2["VIEW_HEALTH_HISTORY"] = "health_profiles.view_healthhistory";
  UserPermission2["VIEW_COVID_REPORTS_QUEUE"] = "results.can_view_covid_reports_queue";
  UserPermission2["ACCESS_PATIENT_DATA"] = "colorhub.access_patient_data";
  UserPermission2["VIEW_PATIENTS_HUB"] = "colorhub.view_patients_hub";
  UserPermission2["USE_GLOBAL_SEARCH"] = "colorhub.use_global_search";
  UserPermission2["VIEW_PATIENT_RECORD"] = "colorhub.view_patient_record";
  UserPermission2["EDIT_PATIENT_DEMOGRAPHICS"] = "colorhub.edit_patient_demographics";
  UserPermission2["EDIT_PATIENT_CONTACT_INFO"] = "colorhub.edit_patient_contact_info";
  UserPermission2["EDIT_PATIENT_INSURANCE"] = "colorhub.edit_patient_insurance";
  UserPermission2["ADD_PATIENT_NOTES"] = "colorhub.add_patient_notes";
  UserPermission2["EDIT_PATIENT_NOTES"] = "colorhub.edit_patient_notes";
  UserPermission2["ARCHIVE_PATIENT_NOTES"] = "colorhub.archive_patient_notes";
  UserPermission2["VIEW_PATIENT_TIMELINE"] = "colorhub.view_patient_timeline";
  UserPermission2["VIEW_PATIENT_GOALS"] = "colorhub.view_patient_goals";
  UserPermission2["EDIT_PATIENT_GOALS"] = "colorhub.edit_patient_goals";
  UserPermission2["ADD_TASK"] = "colorhub.add_task";
  UserPermission2["EDIT_TASK"] = "colorhub.edit_task";
  UserPermission2["ADD_TASK_COMMENTS"] = "colorhub.add_task_comments";
  UserPermission2["EDIT_TASK_COMMENTS"] = "colorhub.edit_task_comments";
  UserPermission2["ARCHIVE_TASK_COMMENTS"] = "colorhub.archive_task_comments";
  UserPermission2["ADD_RISK_ASSESSMENT"] = "colorhub.add_risk_assessment";
  UserPermission2["ADD_DOCUMENT"] = "colorhub.add_document";
  UserPermission2["DELETE_DOCUMENT"] = "colorhub.delete_document";
  UserPermission2["DOWNLOAD_DOCUMENT"] = "colorhub.download_document";
  UserPermission2["EDIT_DOCUMENT"] = "colorhub.edit_document";
  UserPermission2["FAX_DOCUMENT"] = "colorhub.fax_document";
  UserPermission2["SHARE_DOCUMENT"] = "colorhub.share_document";
  UserPermission2["VIEW_DOCUMENT"] = "colorhub.view_document";
  UserPermission2["COLORHUB_ADMIN"] = "colorhub.admin_hub";
  UserPermission2["VIEW_CONTRACT"] = "colorhub.view_contract";
  UserPermission2["EDIT_CONTRACT"] = "colorhub.edit_contract";
  return UserPermission2;
})(UserPermission || {});
var ScopedRoleType = /* @__PURE__ */ ((ScopedRoleType2) => {
  ScopedRoleType2["COVID_OVERVIEW_DASHBOARD_VIEWER"] = "view_covid_overview_dashboard";
  ScopedRoleType2["COVID_PATIENTS_DASHBOARD_VIEWER"] = "view_covid_patients_dashboard";
  ScopedRoleType2["VACCINE_OVERVIEW_DASHBOARD_VIEWER"] = "view_vx_overview_dashboard";
  ScopedRoleType2["VACCINE_PATIENTS_DASHBOARD_VIEWER"] = "view_vx_patients_dashboard";
  ScopedRoleType2["VACCINE_AUDIT_DASHBOARD_VIEWER"] = "view_vx_audit_dashboard";
  ScopedRoleType2["CONTACT_MANAGER"] = "contact_manager";
  ScopedRoleType2["USER_MANAGER"] = "manage_users";
  ScopedRoleType2["API_KEY_MANAGER"] = "api_key_manager";
  ScopedRoleType2["LAB_OVERVIEW_DASHBOARD_VIEWER"] = "lab_overview_dashboard_viewer";
  ScopedRoleType2["LAB_PHI_DASHBOARD_VIEWER"] = "lab_phi_dashboard_viewer";
  ScopedRoleType2["ELIGIBILITY_DATA_MANAGER"] = "eligibility_data_manager";
  ScopedRoleType2["RESEARCH_OVERVIEW_DASHBOARD_VIEWER"] = "research_overview_dashboard_viewer";
  ScopedRoleType2["RESEARCH_CRO_OVERVIEW_DASHBOARD_VIEWER"] = "research_cro_overview_dashboard_viewer";
  ScopedRoleType2["RESEARCH_PATIENTS_DASHBOARD_VIEWER"] = "research_patients_dashboard_viewer";
  ScopedRoleType2["ESSENTIAL_CARE_OVERVIEW_DASHBOARD_VIEWER"] = "essential_care_overview_dashboard_viewer";
  ScopedRoleType2["ESSENTIAL_CARE_PATIENTS_DASHBOARD_VIEWER"] = "essential_care_patients_dashboard_viewer";
  ScopedRoleType2["CONSULTATIONS_OVERVIEW_DASHBOARD_VIEWER"] = "consultations_overview_dashboard_viewer";
  ScopedRoleType2["CONSULTATIONS_PATIENTS_DASHBOARD_VIEWER"] = "consultations_patients_dashboard_viewer";
  ScopedRoleType2["STI_OVERVIEW_DASHBOARD_VIEWER"] = "sti_overview_dashboard_viewer";
  ScopedRoleType2["STI_PATIENTS_DASHBOARD_VIEWER"] = "sti_patients_dashboard_viewer";
  ScopedRoleType2["ONSITE_BATCH_SHIPMENT_ADMIN"] = "onsite_batch_shipment_admin";
  ScopedRoleType2["VACCINATION_PLATFORM_SITE_MANAGER"] = "vaccination_platform_site_manager";
  ScopedRoleType2["VACCINATION_PLATFORM_SITE_STAFF"] = "vaccination_platform_site_staff";
  ScopedRoleType2["VACCINATION_PLATFORM_SCRIBE"] = "vaccination_platform_scribe";
  ScopedRoleType2["VACCINATION_PLATFORM_VACCINATING_CLINICIAN"] = "vaccination_platform_vaccinating_clinician";
  ScopedRoleType2["VACCINATION_PLATFORM_SITE_SCHEDULER"] = "vaccination_platform_site_scheduler";
  ScopedRoleType2["VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER"] = "vaccination_platform_site_inventory_manager";
  ScopedRoleType2["VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER"] = "vaccination_platform_bulk_inventory_manager";
  ScopedRoleType2["VACCINATION_PLATFORM_STAFF_MANAGER"] = "vaccination_platform_staff_manager";
  ScopedRoleType2["VACCINATION_PLATFORM_SUPER_ADMIN"] = "vaccination_platform_super_admin";
  ScopedRoleType2["PROMISE_OVERVIEW_DASHBOARD_VIEWER"] = "promise_overview_dashboard_viewer";
  ScopedRoleType2["PROMISE_PARTICIPANTS_DASHBOARD_VIEWER"] = "promise_participants_dashboard_viewer";
  return ScopedRoleType2;
})(ScopedRoleType || {});
var PermissionType = /* @__PURE__ */ ((PermissionType2) => {
  PermissionType2["UNKNOWN"] = "UNKNOWN";
  PermissionType2["ALLOWED"] = "ALLOWED";
  PermissionType2["NOT_ALLOWED"] = "NOT_ALLOWED";
  return PermissionType2;
})(PermissionType || {});
let nullableLocalStorage = null;
let nullableSessionStorage = null;
try {
  nullableLocalStorage = window.localStorage;
} catch {
}
try {
  nullableSessionStorage = window.sessionStorage;
} catch {
}
var BrowserStorageType = /* @__PURE__ */ ((BrowserStorageType2) => {
  BrowserStorageType2[BrowserStorageType2["LOCAL_STORAGE"] = 0] = "LOCAL_STORAGE";
  BrowserStorageType2[BrowserStorageType2["SESSION_STORAGE"] = 1] = "SESSION_STORAGE";
  return BrowserStorageType2;
})(BrowserStorageType || {});
function getBrowserStorage(browserStorageType) {
  switch (browserStorageType) {
    case 0:
      return nullableLocalStorage;
    case 1:
      return nullableSessionStorage;
    default:
      throw new Error(`Unknown Browser storage type: ${browserStorageType}`);
  }
}
function isPayloadValid(payloadWrapper, options) {
  const { validTimeInMilliseconds = Number.MAX_VALUE } = options;
  const { updatedAt } = payloadWrapper;
  return updatedAt && Date.now() - updatedAt <= validTimeInMilliseconds;
}
function getValidBrowserStoragePayload(browserStorageType, key, initialValue, options) {
  try {
    const item = getBrowserStorage(browserStorageType)?.getItem(key);
    const payloadWrapper = item && JSON.parse(item);
    if (payloadWrapper && isPayloadValid(payloadWrapper, options)) {
      return payloadWrapper.payload;
    }
    return initialValue;
  } catch {
    return initialValue;
  }
}
function setBrowserStoragePayload(browserStorageType, key, payload) {
  try {
    const payloadWrapper = {
      updatedAt: Date.now(),
      payload
    };
    getBrowserStorage(browserStorageType)?.setItem(key, JSON.stringify(payloadWrapper));
  } catch (error) {
    loggerUtils.logException(error);
  }
}
function clearBrowserStoragePayload(browserStorageType, key) {
  try {
    getBrowserStorage(browserStorageType)?.removeItem(key);
  } catch (error) {
    loggerUtils.logException(error);
  }
}
function clearBrowserStorage(browserStorageType) {
  try {
    getBrowserStorage(browserStorageType)?.clear();
  } catch (error) {
    loggerUtils.logException(error);
  }
}
function useBrowserStorageState(browserStorageType, key, initialValue, options = {}) {
  const [storedValue, setStoredValue] = useState(() => {
    return getValidBrowserStoragePayload(browserStorageType, key, initialValue, options);
  });
  const setValue = useCallback(
    (param) => {
      if (typeof param === "function") {
        setStoredValue((currentValue) => {
          const newValue = param(currentValue);
          setBrowserStoragePayload(browserStorageType, key, newValue);
          return newValue;
        });
      } else {
        setStoredValue(param);
        setBrowserStoragePayload(browserStorageType, key, param);
      }
    },
    [key, browserStorageType]
  );
  const clearStorage = useCallback(() => {
    clearBrowserStoragePayload(browserStorageType, key);
  }, [key, browserStorageType]);
  return [storedValue, setValue, clearStorage];
}
const useLocalStorageState = partial(
  useBrowserStorageState,
  BrowserStorageType.LOCAL_STORAGE
);
const useSessionStorageState = partial(
  useBrowserStorageState,
  BrowserStorageType.SESSION_STORAGE
);
function getLaunchDarklyClientId(env) {
  switch (env) {
    case Environment.STAGING:
    case Environment.TESTING:
    case Environment.EPHEMERAL:
      return process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING || "missing-REACT_APP_LAUNCHDARKLY_CLIENTID_STAGING-see-code-comment";
    case Environment.PRODUCTION:
      return process.env.REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION || "missing-REACT_APP_LAUNCHDARKLY_CLIENTID_PRODUCTION-see-code-comment";
    case Environment.LOCAL:
      return "fake-client-id-for-Environment.LOCAL-see-code-comment";
    case Environment.UNKNOWN:
    default:
      return "fake-client-id-for-Environment.UNKNOWN-see-code-comment";
  }
}
class FakeLaunchDarklyClient {
  flags = {};
  user;
  constructor(flags, ldUser) {
    this.flags = flags;
    this.user = ldUser;
  }
  // eslint-disable-next-line class-methods-use-this
  waitUntilGoalsReady() {
    return Promise.resolve();
  }
  // eslint-disable-next-line class-methods-use-this
  waitUntilReady() {
    return Promise.resolve();
  }
  // eslint-disable-next-line class-methods-use-this
  waitForInitialization() {
    return Promise.resolve();
  }
  identify(user, _hash, onDone) {
    this.user = user;
    if (onDone) {
      onDone(null, this.flags);
    }
    return Promise.resolve(this.flags);
  }
  getUser() {
    return this.user;
  }
  // eslint-disable-next-line class-methods-use-this
  flush(onDone) {
    onDone?.();
    return Promise.resolve();
  }
  variation(key, defaultValue) {
    return this.flags[key] || defaultValue;
  }
  variationDetail(key, defaultValue) {
    const reason = {
      kind: "FALLTHROUGH"
    };
    const detail = {
      value: this.flags[key] || defaultValue,
      variationIndex: 0,
      reason
    };
    return detail;
  }
  // eslint-disable-next-line class-methods-use-this
  setStreaming() {
  }
  // eslint-disable-next-line class-methods-use-this
  on() {
  }
  // eslint-disable-next-line class-methods-use-this
  off() {
  }
  // eslint-disable-next-line class-methods-use-this
  track() {
  }
  // eslint-disable-next-line class-methods-use-this
  alias() {
  }
  allFlags() {
    return this.flags;
  }
  // eslint-disable-next-line class-methods-use-this
  close(onDone) {
    onDone?.();
    return Promise.resolve();
  }
}
const FakeLaunchDarklyFlagContextProvider = (props) => {
  const { flags = {}, user = { key: "fake-ld-flag-provider-user" }, children } = props;
  const fakeLdContext = {
    flags,
    flagKeyMap: {},
    ldClient: new FakeLaunchDarklyClient(flags, user)
  };
  return /* @__PURE__ */ jsx(Provider, { value: fakeLdContext, children });
};
const GLOBAL_COOKIES = new Cookies();
const SIGNED_IN_LD_USER_KEY_COOKIE_NAME = "ld_user_key";
function getLaunchDarklyUserKeyCookieValue() {
  return GLOBAL_COOKIES.get(SIGNED_IN_LD_USER_KEY_COOKIE_NAME, { doNotParse: true });
}
async function FakeLaunchDarklyProviderHoc() {
  const clientSideFlags = await fetch(
    "/api/v1/testing/client_side_flags"
  ).then((response) => {
    if (!response.ok) {
      throw new Error(
        `Non-200 error code returned when fetching /api/v1/testing/client_side_flags for LaunchDarkly local dev set up. Was ${response.status}`
      );
    }
    const contentType = response.headers.get("content-type");
    const isJson = contentType?.includes("application/json");
    if (!isJson) {
      throw new Error(
        `Non-JSON response returned when fetching /api/v1/testing/client_side_flags for LaunchDarkly local dev set up. Has Content-Type '${contentType}'`
      );
    }
    return response.json();
  });
  const userKey = getLaunchDarklyUserKeyCookieValue();
  const user = userKey ? { key: userKey } : { key: "missing-ld-user-key-but-maybe-okay-for-now" };
  const flags = clientSideFlags.flag_data;
  const FakeLdFlagContextProvider = ({ children }) => /* @__PURE__ */ jsx(FakeLaunchDarklyFlagContextProvider, { flags, user, children });
  return Promise.resolve(FakeLdFlagContextProvider);
}
const logToConsole = (message) => loggerUtils.logMessageToConsole(`[Launch Darkly] ${message}`);
const ldLogger = {
  debug: () => null,
  // Don't log debug messages in staging/prod
  info: logToConsole,
  warn: logToConsole,
  error: (message) => {
    if (message && message.includes("network error")) {
      logToConsole(message);
    } else {
      loggerUtils.logException(new Error(`[Launch Darkly] ${message}`));
    }
  }
};
async function RealLaunchDarklyProviderHoc(clientId) {
  const userKey = getLaunchDarklyUserKeyCookieValue();
  const user = userKey ? { key: userKey } : { anonymous: true };
  const config = {
    user,
    clientSideID: clientId,
    reactOptions: {
      useCamelCaseFlagKeys: false
    },
    options: {
      logger: ldLogger
    }
  };
  return asyncWithLDProvider(config);
}
async function FeatureFlagProviderHoc() {
  const env = getEnvironment();
  switch (env) {
    case Environment.PRODUCTION:
    case Environment.STAGING:
    case Environment.EPHEMERAL:
    case Environment.TESTING:
      return RealLaunchDarklyProviderHoc(getLaunchDarklyClientId(env));
    case Environment.LOCAL:
    case Environment.UNKNOWN:
    default:
      if (process.env.REACT_APP_LAUNCHDARKLY_FORCE_LOCAL_REQUESTS_TO_CLIENT_ID != null) {
        return RealLaunchDarklyProviderHoc(
          process.env.REACT_APP_LAUNCHDARKLY_FORCE_LOCAL_REQUESTS_TO_CLIENT_ID
        );
      }
      return FakeLaunchDarklyProviderHoc();
  }
}
const useLaunchDarklyUpdater = () => {
  const ldClient = useLDClient();
  if (!ldClient) {
    throw new Error(
      "useLaunchDarklyUpdateUser must be used within a ConfiguredFeatureFlagsProvider context"
    );
  }
  const updateLaunchDarkly = async () => {
    const newLDUserKey = getLaunchDarklyUserKeyCookieValue();
    const currentLdUserKey = ldClient.getUser().key;
    if (newLDUserKey === currentLdUserKey) {
      return;
    }
    const user = newLDUserKey ? { key: newLDUserKey } : { anonymous: true };
    try {
      await ldClient.identify(user);
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setTag("subsystem", "feature-flags");
        loggerUtils.logException(error);
      });
    }
  };
  return { updateLaunchDarkly };
};
const HTTP_UNATHENTICATED_STATUSES = /* @__PURE__ */ new Set([401, 403]);
const AUTH_HEARTBEAT_INTERVAL_IN_MSEC = 6e4;
function useIdentifySegmentUser() {
  const lastUserIdRef = useRef("");
  const updateSegmentUser = useCallback(
    (user, properties = {}) => {
      const patientId = user?.patient_id;
      if (patientId && patientId !== lastUserIdRef.current) {
        identifyAnalyticsUser({ patientId, isColorEmployee: user.is_color_employee, properties });
        lastUserIdRef.current = patientId;
      }
    },
    []
  );
  return { updateSegmentUser };
}
function clearSessionState() {
  clearBrowserStorage(BrowserStorageType.SESSION_STORAGE);
}
function useAuthState(props = {}) {
  const {
    baseUrl = "",
    sessionRefetchIntervalMs = AUTH_HEARTBEAT_INTERVAL_IN_MSEC,
    sessionRefetchIntervalInBackground = false,
    authUserStaleTimeMs = 0
  } = props;
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { updateSegmentUser } = useIdentifySegmentUser();
  const { updateLaunchDarkly } = useLaunchDarklyUpdater();
  const resetState = useCallback(() => {
    clearSessionState();
    setIsAuthenticated(false);
  }, []);
  const sessionResponse = useAuthSession(
    {
      retry: false,
      refetchInterval: sessionRefetchIntervalMs,
      refetchIntervalInBackground: sessionRefetchIntervalInBackground,
      onSuccess: () => {
        setIsAuthenticated(true);
      },
      onError: (error) => {
        if (HTTP_UNATHENTICATED_STATUSES.has(error?.status)) {
          setIsAuthenticated(false);
        }
      },
      onSettled: async () => {
        await updateLaunchDarkly();
      }
    },
    baseUrl
  );
  const authenticatedUserResponse = useAuthenticatedUser(
    isAuthenticated,
    {
      refetchOnWindowFocus: isAuthenticated,
      staleTime: authUserStaleTimeMs,
      onSuccess: (user) => {
        updateSegmentUser(user);
        Sentry.setUser(user ? { id: user.id.toString() } : null);
      }
    },
    baseUrl
  );
  const {
    data: currentUser,
    refetch: fetchUser,
    isFetched: userIsFetched,
    remove: clearAuthenticatedUser
  } = authenticatedUserResponse;
  const {
    isFetched: hasInitializedSession,
    refetch: updateSession,
    error: sessionError
  } = sessionResponse;
  const signIn = useCallback(
    async (email, password, nextUrl) => {
      try {
        const createSessionUrl = appendQueryParams(`${baseUrl}${SESSIONS_ENDPOINT}`, {
          next: nextUrl
        });
        const response = await ApiClient.post(createSessionUrl, {
          json: {
            email,
            password
          }
        });
        const isMfaRequired = response?.is_mfa_required ?? false;
        if (isMfaRequired) {
          setIsAuthenticated(false);
          return {
            isSuccessful: false,
            mfaConfig: { factors: response?.factors ?? [] }
          };
        }
        const emailNeedsConfirmation = response?.email_needs_confirmation ?? false;
        if (emailNeedsConfirmation) {
          setIsAuthenticated(false);
          return {
            isSuccessful: false,
            emailNeedsConfirmation: true
          };
        }
        trackAnalyticsEvent("Sign In - Succeeded", {
          is_mfa: "no"
        });
        setIsAuthenticated(true);
        await updateLaunchDarkly();
        return { isSuccessful: true };
      } catch (error) {
        trackAnalyticsEvent("Sign In - Failed", {
          error: error instanceof Error ? error.message : error?.toString?.() ?? "",
          status: error instanceof ApiError ? error.status : ""
        });
        setIsAuthenticated(false);
        throw error;
      }
    },
    [updateLaunchDarkly, baseUrl]
  );
  const signOut = useCallback(async () => {
    try {
      await ApiClient.delete(`${baseUrl}${SESSIONS_ENDPOINT}`);
    } catch (error) {
      if (error.status !== 401) {
        throw error;
      }
    }
    clearAuthenticatedUser();
    clearSessionState();
    resetAnalyticsUser();
    Sentry.setUser(null);
    setIsAuthenticated(false);
    try {
      await updateSession();
    } catch {
    }
  }, [clearAuthenticatedUser, updateSession, baseUrl]);
  const sessionErrorIsUnauthenticatedStatus = hasInitializedSession && sessionError != null && HTTP_UNATHENTICATED_STATUSES.has(sessionError.status);
  const resetStateAndUpdateSession = useCallback(async () => {
    resetState();
    const updateSessionResponse = await updateSession();
    let attemptCount = 1;
    let hasSucceeded = updateSessionResponse.isSuccess;
    if (!hasSucceeded) {
      const retriedUpdateSessionResponse = await updateSession();
      attemptCount += 1;
      hasSucceeded = retriedUpdateSessionResponse.isSuccess;
    }
    trackAnalyticsEvent("Session Refresh", {
      status: hasSucceeded ? "succeeded" : "failed",
      attempt_count: attemptCount
    });
  }, [resetState, updateSession]);
  return {
    currentUser,
    hasInitializedUser: userIsFetched || sessionErrorIsUnauthenticatedStatus,
    hasInitializedSession,
    isAuthenticated,
    resetStateAndUpdateSession,
    signIn,
    signOut,
    fetchUser
  };
}
const [AuthProvider, useAuthContext] = constate(useAuthState);
var KitOrderTestType = /* @__PURE__ */ ((KitOrderTestType2) => {
  KitOrderTestType2["HEREDITARY_30"] = "hereditary 30";
  KitOrderTestType2["HEREDITARY_25"] = "hereditary 25";
  KitOrderTestType2["HEREDITARY_41"] = "hereditary 41";
  KitOrderTestType2["BREAST_OVARIAN_19"] = "breast ovarian 19";
  KitOrderTestType2["WISDOM_9"] = "wisdom 9";
  KitOrderTestType2["FH_5"] = "fh 5";
  KitOrderTestType2["FH_3"] = "fh 3";
  KitOrderTestType2["CARDIO_30"] = "cardio 30";
  KitOrderTestType2["WES"] = "whole exome";
  KitOrderTestType2["WGS"] = "whole genome";
  KitOrderTestType2["LCWGS"] = "low coverage whole genome";
  KitOrderTestType2["BRCA_1_2"] = "brca 1 2";
  KitOrderTestType2["HEREDITARY_7"] = "hereditary 7";
  KitOrderTestType2["PGX_V1"] = "pgx v1";
  KitOrderTestType2["PGX_V3"] = "pgx v3";
  KitOrderTestType2["PMS_2"] = "pms2";
  KitOrderTestType2["ACMG_59"] = "acmg 59";
  KitOrderTestType2["HDR_59"] = "hdr 59";
  KitOrderTestType2["METABOLISM_4"] = "metabolism 4";
  KitOrderTestType2["COVID_19"] = "covid-19";
  KitOrderTestType2["COVID_19_ANTIGEN"] = "covid-19 antigen";
  KitOrderTestType2["ESSENTIAL_CARE_KIT"] = "preventive health kit";
  KitOrderTestType2["AOU_HDR_V1"] = "aou acmg 59";
  KitOrderTestType2["AOU_PGX_V1"] = "aou pgx v1";
  KitOrderTestType2["CHLAMYDIA_ANAL"] = "chlamydia trachomatis - anal";
  KitOrderTestType2["CHLAMYDIA_ORAL"] = "chlamydia trachomatis - oral";
  KitOrderTestType2["CHLAMYDIA_URINE"] = "chlamydia trachomatis - urine";
  KitOrderTestType2["GONORRHEA_ANAL"] = "neisseria gonorrhoeae - anal";
  KitOrderTestType2["GONORRHEA_ORAL"] = "neisseria gonorrhoeae - oral";
  KitOrderTestType2["GONORRHEA_URINE"] = "neisseria gonorrhoeae - urine";
  return KitOrderTestType2;
})(KitOrderTestType || {});
var KitOrderStatus = /* @__PURE__ */ ((KitOrderStatus2) => {
  KitOrderStatus2["NO_ORDER"] = "no_order";
  KitOrderStatus2["ONSITE_PURCHASE"] = "onsite_purchase";
  KitOrderStatus2["NOT_SHIPPED"] = "not_shipped";
  KitOrderStatus2["SHIPPED_TO_HOME"] = "shipped_to_home";
  KitOrderStatus2["SHIPPED_TO_HOME_FAILED"] = "shipped_to_home_failed";
  KitOrderStatus2["DELIVERED_TO_HOME"] = "delivered_to_home";
  KitOrderStatus2["DELIVERED_TO_HOME_ACTIVATED"] = "delivered_to_home_activated";
  KitOrderStatus2["COLLECTED_ONSITE_ACTIVATED"] = "collected_onsite_activated";
  KitOrderStatus2["SHIPPED_TO_LAB"] = "shipped_to_lab";
  KitOrderStatus2["USPS_LOST_PACKAGE"] = "usps_lost_package";
  KitOrderStatus2["USPS_LOST_PACKAGE_NEW_KIT_SHIPPED"] = "usps_lost_package_new_kit_shipped";
  KitOrderStatus2["AT_LAB_SEQUENCING"] = "at_lab_sequencing";
  KitOrderStatus2["AT_LAB_SEQUENCING_KNOWN_DELAY"] = "at_lab_sequencing_known_delay";
  KitOrderStatus2["AT_LAB_SEQUENCING_UNKNOWN_DELAY"] = "at_lab_sequencing_unknown_delay";
  KitOrderStatus2["AT_LAB_NOT_ACTIVATED"] = "at_lab_not_activated";
  KitOrderStatus2["AT_LAB_DATA_REUSE"] = "at_lab_data_reuse";
  KitOrderStatus2["PENDING_EXTERNAL_PHYSICIAN"] = "pending_external_physician";
  KitOrderStatus2["PENDING_GC_SESSION"] = "pending_gc_session";
  KitOrderStatus2["RELEASED_NOT_OPENED"] = "released_not_opened";
  KitOrderStatus2["RELEASED_AND_OPENED"] = "released_opened";
  KitOrderStatus2["RERELEASED_NOT_OPENED"] = "rereleased_not_opened";
  KitOrderStatus2["RERELEASED_AND_OPENED"] = "rereleased_opened";
  KitOrderStatus2["WISDOM_ORDER"] = "wisdom_order";
  KitOrderStatus2["CANCELED_ORDER"] = "canceled";
  return KitOrderStatus2;
})(KitOrderStatus || {});
const ReleasedReportStates = [
  "released_not_opened",
  "released_opened",
  "rereleased_not_opened",
  "rereleased_opened"
  /* RERELEASED_AND_OPENED */
];
const CANCER_TEST_TYPES = [
  "hereditary 30",
  "hereditary 25",
  "hereditary 41",
  "breast ovarian 19",
  "wisdom 9",
  "brca 1 2",
  "hereditary 7",
  "pms2"
  /* PMS_2 */
];
const GENETIC_TEST_TYPES = [
  ...CANCER_TEST_TYPES,
  "fh 5",
  "fh 3",
  "cardio 30",
  "whole exome",
  "whole genome",
  "low coverage whole genome",
  "pgx v1",
  "pgx v3",
  "metabolism 4",
  "acmg 59",
  "hdr 59",
  "aou acmg 59",
  "aou pgx v1"
  /* AOU_PGX_V1 */
];
const COVID_TEST_TYPES = [
  "covid-19",
  "covid-19 antigen"
  /* COVID_19_ANTIGEN */
];
const ESSENTIAL_CARE_TEST_TYPES = [
  "preventive health kit"
  /* ESSENTIAL_CARE_KIT */
];
const STI_TEST_TYPES = [
  "chlamydia trachomatis - anal",
  "chlamydia trachomatis - oral",
  "chlamydia trachomatis - urine",
  "neisseria gonorrhoeae - anal",
  "neisseria gonorrhoeae - oral",
  "neisseria gonorrhoeae - urine"
  /* GONORRHEA_URINE */
];
function getRoles(user) {
  const userIsNonDependentProxy = user.is_proxy && !user.is_dependent;
  const hasCovidTest = user.test_types.some((testType) => COVID_TEST_TYPES.includes(testType)) || user.has_user_reported_test_results;
  const hasCovidServices = hasCovidTest || user.has_vaccination_status;
  const hasStiTest = user.test_types.some((testType) => STI_TEST_TYPES.includes(testType));
  const userHasEssentialCareTest = intersection(user.test_types, ESSENTIAL_CARE_TEST_TYPES).length > 0;
  const roleConditions = {
    [UserRole.USER_WITH_ACCOUNT]: !user.is_proxy,
    [UserRole.NO_TEST]: !user.test_types.length,
    [UserRole.COVID_NON_DEPENDENT_PROXY]: hasCovidServices && userIsNonDependentProxy,
    /**
     * FIXME: This relies on a temporary property that will be removed.
     * See https://getcolor.atlassian.net/browse/ANTI-286
     */
    [UserRole.COVID_FULL_USER_OR_DEPENDENT]: hasCovidServices && !userIsNonDependentProxy,
    [UserRole.ESSENTIAL_CARE_USER]: userHasEssentialCareTest,
    [UserRole.CARE_FULL_USER_OR_DEPENDENT]: userHasEssentialCareTest || user.deprecated_has_been_consulted_for_paxlovid,
    [UserRole.STI_TEST_USER]: hasStiTest,
    [UserRole.COVID_SITE_MANAGER]: user.is_covid_site_manager,
    [UserRole.GENETICS]: (
      // By default, we should assume somebody does not (yet) have the GENETICS role, unless they buy a kit.
      // Users without tests are not genetics users.
      user.test_types.some((testType) => GENETIC_TEST_TYPES.includes(testType))
    ),
    [UserRole.PROVIDER]: user.is_provider,
    [UserRole.COLOR_EMPLOYEE]: user.is_color_employee,
    [UserRole.DASHBOARD_VIEWER]: user.is_dashboard_viewer,
    [UserRole.ACCESS_MANAGER]: user.is_access_manager,
    [UserRole.SUPPORT_STAFF]: user.is_support_staff,
    [UserRole.SUPPORT_ADMIN]: user.is_support_admin,
    [UserRole.SAMPLE_REVIEWER]: user.is_sample_reviewer,
    [UserRole.ORDERING_PHYSICIAN]: user.is_ordering_physician,
    [UserRole.GENETIC_COUNSELOR]: user.is_genetic_counselor,
    [UserRole.EXTERNAL_CLASSIFICATION_REVIEWER]: user.is_external_classification_reviewer,
    [UserRole.VARIANT_REVIEWER]: user.is_variant_reviewer,
    [UserRole.VARIANT_REVIEWER_MANAGER]: user.is_variant_reviewer_manager,
    [UserRole.GENETICS_BOARD_MEMBER]: user.is_genetics_board_member,
    [UserRole.PATHOLOGIST]: user.is_pathologist,
    [UserRole.COLLECTION_SITE_ADMIN]: user.collection_site_permissions?.length > 0 || user.roles?.some(
      (role) => role.scope_content_type === "collection-site" || role.role_type === ScopedRoleType.VACCINATION_PLATFORM_SUPER_ADMIN
    ),
    [UserRole.FULFILLMENT_STAFF]: user.is_fulfillment_staff,
    // TODO: VAX-4858 This "getRoles()" function relies primarily on the Group model
    // but these two rely on the Role model. We need a larger refactor to handle consistently.
    // Minimum: extract this into a util function for hasScopedRole().
    [UserRole.CONTACT_MANAGER]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.CONTACT_MANAGER
    ),
    [UserRole.ELIGIBILITY_DATA_MANAGER]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.ELIGIBILITY_DATA_MANAGER
    ),
    [UserRole.VACCINATION_PLATFORM_SUPER_ADMIN]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_SUPER_ADMIN
    ),
    [UserRole.VACCINATION_PLATFORM_STAFF_MANAGER]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_STAFF_MANAGER
    ),
    [UserRole.VACCINATION_PLATFORM_SITE_MANAGER]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_SITE_MANAGER
    ),
    [UserRole.VACCINATION_PLATFORM_SCRIBE]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_SCRIBE
    ),
    [UserRole.VACCINATION_PLATFORM_SITE_STAFF]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_SITE_STAFF
    ),
    [UserRole.VACCINATION_PLATFORM_VACCINATING_CLINICIAN]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_VACCINATING_CLINICIAN
    ),
    [UserRole.VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_SITE_INVENTORY_MANAGER
    ),
    [UserRole.VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER]: user.roles?.some(
      (role) => role.role_type === ScopedRoleType.VACCINATION_PLATFORM_BULK_INVENTORY_MANAGER
    )
  };
  return Object.values(UserRole).filter((role) => roleConditions[role]);
}
function getFullName(user) {
  return `${user.first_name} ${user.last_name}`;
}
function hasRole(user, role) {
  const userRoles = getRoles(user);
  return userRoles.includes(role);
}
function hasAnyRoles(user, roles) {
  const userRoles = getRoles(user);
  return roles.some((role) => userRoles.includes(role));
}
function hasPermissions(user, permissions) {
  return permissions.every((permission) => Boolean(user.permissions[permission]));
}
function isUserAuthorized(currentUser, authProps) {
  const { allowedRoles = [], requiredPermissions = [], signedOutUserIsAllowed = false } = authProps;
  if (currentUser) {
    const userHasAllowedRoles = allowedRoles.some(
      (role) => hasRole(currentUser, role) || currentUser.dependents.some((dependent) => hasRole(dependent, role))
    );
    const userHasPermissions = hasPermissions(currentUser, requiredPermissions);
    if (allowedRoles.length > 0 && requiredPermissions.length > 0) {
      throw new Error("Both roles and permissions are specified.  You likely only want one set.");
    } else if (allowedRoles.length > 0) {
      return userHasAllowedRoles;
    } else if (requiredPermissions.length > 0) {
      return userHasPermissions;
    }
    return true;
  }
  return signedOutUserIsAllowed;
}
function useAuthorization(props) {
  const { hasInitializedUser, currentUser } = useAuthContext();
  const { allowedRoles, requiredPermissions, signedOutUserIsAllowed } = props;
  if (hasInitializedUser) {
    const userIsAuthorized = isUserAuthorized(currentUser, {
      allowedRoles,
      requiredPermissions,
      signedOutUserIsAllowed
    });
    return userIsAuthorized ? PermissionType.ALLOWED : PermissionType.NOT_ALLOWED;
  }
  return PermissionType.UNKNOWN;
}
const COLOR_DATE_FORMAT = `PP`;
const COLOR_LONG_DATE_FORMAT = "PPPP";
const COLOR_TIME_FORMAT = "p";
const COLOR_DATETIME_FORMAT = `${COLOR_DATE_FORMAT}, ${COLOR_TIME_FORMAT}`;
const COLOR_TIMEZONE_FORMAT = "zzz";
const COLOR_TIME_WITH_TIMEZONE_FORMAT = `${COLOR_TIME_FORMAT} ${COLOR_TIMEZONE_FORMAT}`;
const COLOR_DATETIME_WITH_TIMEZONE_FORMAT = `${COLOR_DATE_FORMAT}, ${COLOR_TIME_FORMAT} ${COLOR_TIMEZONE_FORMAT}`;
const COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT = `PPPPp ${COLOR_TIMEZONE_FORMAT}`;
const VALID_DATETIME_FORMATS = [
  COLOR_DATE_FORMAT,
  COLOR_LONG_DATE_FORMAT,
  COLOR_TIME_FORMAT,
  COLOR_DATETIME_FORMAT,
  COLOR_TIMEZONE_FORMAT,
  COLOR_DATETIME_WITH_TIMEZONE_FORMAT,
  COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT,
  COLOR_TIME_WITH_TIMEZONE_FORMAT
];
class DateTimeFormatError extends Error {
  constructor(dateFormat) {
    super(`Unexpected date time format ${dateFormat}`);
  }
}
function getZonedDateTimeFromDateTime(dateTime, timeZone) {
  let dateObj = isString(dateTime) ? parseISO(dateTime) : dateTime;
  if (timeZone) {
    dateObj = utcToZonedTime(dateTime, timeZone);
  }
  return dateObj;
}
function formatDateTimeWithFormat(dateTime, dateFormat, options) {
  if (!VALID_DATETIME_FORMATS.includes(dateFormat)) {
    throw new DateTimeFormatError(dateFormat);
  }
  return format(getZonedDateTimeFromDateTime(dateTime, options?.timeZone), dateFormat, options);
}
function formatDate(date, options) {
  return formatDateTimeWithFormat(date, COLOR_DATE_FORMAT, options);
}
function formatLongDate(date, options) {
  return formatDateTimeWithFormat(date, COLOR_LONG_DATE_FORMAT, options);
}
function formatDateTime(date, options) {
  return formatDateTimeWithFormat(date, COLOR_DATETIME_FORMAT, options);
}
function formatTime(date, options) {
  return formatDateTimeWithFormat(date, COLOR_TIME_FORMAT, options);
}
function formatTimeZone(date, options) {
  return formatDateTimeWithFormat(date, COLOR_TIMEZONE_FORMAT, options);
}
function formatTimeWithTimeZone(date, options) {
  return formatDateTimeWithFormat(date, COLOR_TIME_WITH_TIMEZONE_FORMAT, options);
}
function formatDateTimeWithTimeZone(date, options) {
  return formatDateTimeWithFormat(date, COLOR_DATETIME_WITH_TIMEZONE_FORMAT, options);
}
function formatLongDateTimeWithTimeZone(date, options) {
  return formatDateTimeWithFormat(date, COLOR_LONG_DATETIME_WITH_TIMEZONE_FORMAT, options);
}
function formatShortDate(date, options) {
  const zonedTime = getZonedDateTimeFromDateTime(date, options?.timeZone);
  return zonedTime.toLocaleDateString(options?.locale, { month: "short", day: "numeric" });
}
function formatDateWithoutYear(date, options) {
  const zonedTime = getZonedDateTimeFromDateTime(date, options?.timeZone);
  return zonedTime.toLocaleDateString(options?.locale, { month: "long", day: "numeric" });
}
function formatDateWithMonthAndYear(date, options) {
  const zonedTime = getZonedDateTimeFromDateTime(date, options?.timeZone);
  return zonedTime.toLocaleDateString(options?.locale, {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
}
function formatDateRange(dateRange) {
  return `${formatShortDate(dateRange.start)} - ${formatShortDate(dateRange.end)}`;
}
function formatShortDateTime(dateTime, options) {
  const zonedDateTime = getZonedDateTimeFromDateTime(dateTime, options?.timeZone);
  if (isToday(zonedDateTime)) {
    return zonedDateTime.toLocaleTimeString(options?.locale, {
      hour: "numeric",
      minute: "2-digit"
    });
  }
  return dateTime.toLocaleDateString(options?.locale, {
    month: "numeric",
    day: "numeric",
    year: isFuture(zonedDateTime) ? "numeric" : "2-digit"
  });
}
function getDateFromTimeString(date, timeString, timeZone) {
  let newDate;
  if (/:..:/.test(timeString)) {
    newDate = parse(timeString, "HH:mm:ss", date);
  } else {
    newDate = parse(timeString, "HH:mm", date);
  }
  if (!isValid(newDate)) {
    throw new Error(`Failed to parse '${timeString}' into a time.`);
  }
  if (timeZone) {
    return zonedTimeToUtc(newDate, timeZone);
  }
  return newDate;
}
const getPlainDateFrom = Temporal.PlainDate.from;
const getCurrentPlainDate = () => {
  return Temporal.Now.plainDateISO();
};
const getPlainDateOrNullFrom = (item) => {
  try {
    return getPlainDateFrom(item, { overflow: "reject" });
  } catch {
    return null;
  }
};
const getPlainDateOrNullFromDate = (date) => {
  try {
    return toTemporalInstant.apply(date).toZonedDateTimeISO(Temporal.Now.timeZone()).toPlainDate();
  } catch {
    return null;
  }
};
const getZonedDateTimeOrNullFromIsoDateTimeString = (dateTimeString) => {
  try {
    return Temporal.ZonedDateTime.from(`${dateTimeString}[${Temporal.Now.timeZone()}]`, {
      overflow: "reject",
      offset: "use"
    });
  } catch {
    return null;
  }
};
const getZonedDateTimeOrNullFromIsoDateString = (dateString, options) => {
  try {
    return getPlainDateFrom(dateString).toZonedDateTime({
      timeZone: options?.timeZone ?? Temporal.Now.timeZone(),
      plainTime: options?.plainTime
    });
  } catch {
    return null;
  }
};
const isPlainDateAfter = (date, dateToCompare) => {
  return Temporal.PlainDate.compare(date, dateToCompare) > 0;
};
const isPlainDateBefore = (date, dateToCompare) => {
  return Temporal.PlainDate.compare(date, dateToCompare) < 0;
};
const getAgeInYearsFromBirthdayIsoDateString = (birthdayIsoString) => {
  const birthdayPlainDate = getPlainDateOrNullFrom(birthdayIsoString);
  if (!birthdayPlainDate) {
    throw new Error(`Cannot calculate age from invalid ISO date, ${birthdayIsoString}`);
  }
  const age = getCurrentPlainDate().since(birthdayPlainDate, {
    largestUnit: "year"
  }).years;
  return age;
};
const getAgeInMonthsFromBirthdayIsoDateString = (birthdayIsoString) => {
  const birthdayPlainDate = getPlainDateOrNullFrom(birthdayIsoString);
  if (!birthdayPlainDate) {
    throw new Error(`Cannot calculate age from invalid ISO date, ${birthdayIsoString}`);
  }
  const age = getCurrentPlainDate().since(birthdayPlainDate, {
    largestUnit: "month"
  }).months;
  return age;
};
const isBirthdayIsoDateStringAtLeastNYearsOld = (birthday, minimumAgeInYears) => {
  return getAgeInYearsFromBirthdayIsoDateString(birthday) >= minimumAgeInYears;
};
function isBirthdayIsoDateStringAdultAge(birthday) {
  return getAgeInYearsFromBirthdayIsoDateString(birthday) >= ADULT_MINIMUM_AGE;
}
function formatLongIsoDateString(date, locale = document.documentElement.lang) {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot format an invalid date, ${date}`);
  }
  return plainDate.toLocaleString(locale || void 0, {
    dateStyle: "long"
  });
}
function formatShortIsoDateString(date, locale = document.documentElement.lang) {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot format an invalid date, ${date}`);
  }
  return plainDate.toLocaleString(locale || void 0, {
    dateStyle: "short"
  });
}
function formatIsoDateStringForTable(date, locale = document.documentElement.lang) {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot format an invalid date, ${date}`);
  }
  const shortWeekdayString = plainDate.toLocaleString(locale || void 0, {
    weekday: "short"
  });
  const numericDay = plainDate.toLocaleString(locale || void 0, {
    day: "numeric"
  });
  return `${shortWeekdayString} ${numericDay}`;
}
const US_DATE_STRING_LENGTH = 10;
const getIsoDateFieldsFromIsoDateString = (isoString) => {
  const plainDate = getPlainDateOrNullFrom(isoString);
  if (plainDate) {
    return {
      year: plainDate.year,
      month: plainDate.month,
      day: plainDate.day
    };
  }
  return null;
};
const getIsoDateStringFromIsoDateFields = (isoDateFields) => {
  const plainDate = getPlainDateOrNullFrom(isoDateFields);
  if (plainDate) {
    return plainDate.toString();
  }
  return null;
};
const getDateFromIsoDateString = (isoString) => {
  const zonedDateTime = getZonedDateTimeOrNullFromIsoDateString(isoString);
  if (zonedDateTime) {
    return new Date(zonedDateTime.epochMilliseconds);
  }
  return null;
};
const getIsoDateStringFromDate = (date) => {
  const plainDate = getPlainDateOrNullFromDate(date);
  if (plainDate) {
    return plainDate.toString();
  }
  return null;
};
const getIsoDateStringFromIsoLongDateTimeString = (dateTimeString) => {
  const zonedDateTime = getZonedDateTimeOrNullFromIsoDateTimeString(dateTimeString);
  if (zonedDateTime) {
    return zonedDateTime.toPlainDate().toString();
  }
  return null;
};
const isIsoDateStringValid = (isoString) => {
  return Boolean(getPlainDateOrNullFrom(isoString));
};
const isIsoDateFieldsValid = (isoDateFields) => {
  return Boolean(getPlainDateOrNullFrom(isoDateFields));
};
const getIsoDateStringForToday = () => {
  return getCurrentPlainDate().toString();
};
function getIsoDateStringBeforeToday(interval) {
  return getCurrentPlainDate().subtract(interval).toString();
}
function getIsoDateStringAfterToday(interval) {
  return getCurrentPlainDate().add(interval).toString();
}
function addToIsoDateString(date, interval) {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot add to invalid ISO date, ${date}`);
  }
  return plainDate.add(interval).toString();
}
function subtractFromIsoDateString(date, interval) {
  const plainDate = getPlainDateOrNullFrom(date);
  if (!plainDate) {
    throw new Error(`Cannot subtract from invalid ISO date, ${date}`);
  }
  return plainDate.subtract(interval).toString();
}
const isIsoDateStringAfter = (date, dateToCompare) => {
  const plainDate = getPlainDateOrNullFrom(date);
  const plainDateToCompare = getPlainDateOrNullFrom(dateToCompare);
  if (!plainDate || !plainDateToCompare) {
    throw new Error("isIsoDateAfter requires two valid IsoDates to compare");
  }
  return isPlainDateAfter(plainDate, plainDateToCompare);
};
const isIsoDateStringBefore = (date, dateToCompare) => {
  const plainDate = getPlainDateOrNullFrom(date);
  const plainDateToCompare = getPlainDateOrNullFrom(dateToCompare);
  if (!plainDate || !plainDateToCompare) {
    throw new Error("isIsoDateBefore requires two valid IsoDates to compare");
  }
  return isPlainDateBefore(plainDate, plainDateToCompare);
};
function getIsoDateStringFromUsDateString(dateString) {
  if (dateString.length !== US_DATE_STRING_LENGTH) {
    return null;
  }
  const [month, day, year] = dateString.split("/");
  const isoDateString = `${year}-${month}-${day}`;
  return isIsoDateStringValid(isoDateString) ? isoDateString : null;
}
function getUsDateStringFromIsoDateString(dateString) {
  if (!isIsoDateStringValid(dateString)) {
    return null;
  }
  const [year, month, day] = dateString.split("-");
  return `${month}/${day}/${year}`;
}
const getStartOfDayFromIsoDateString = (isoString) => {
  const zonedDateTime = getZonedDateTimeOrNullFromIsoDateString(isoString);
  if (!zonedDateTime) {
    throw new Error(`Cannot get start of day from invalid iso date string, ${isoString}`);
  }
  return zonedDateTime.startOfDay().toString({ timeZoneName: "never" });
};
const getEndOfDayFromIsoDateString = (isoString) => {
  const zonedDateTime = getZonedDateTimeOrNullFromIsoDateString(isoString, {
    plainTime: "23:59:59.999"
  });
  if (!zonedDateTime) {
    throw new Error(`Cannot get start of day from invalid iso date string, ${isoString}`);
  }
  return zonedDateTime.toString({ timeZoneName: "never" });
};
function toIsoDateStringDateRange(startDateString, endDateString) {
  if (!isIsoDateStringValid(startDateString) || !isIsoDateStringValid(endDateString)) {
    throw new Error(
      `Cannot create date range with invalid dates. Received (${startDateString}, ${endDateString})`
    );
  }
  if (isIsoDateStringAfter(startDateString, endDateString)) {
    throw new Error(`Date range is invalid, ${startDateString} must be before ${endDateString}`);
  }
  return {
    start: startDateString,
    end: endDateString
  };
}
function formatIsoDateStringDateRange(dateRange) {
  return `${formatShortIsoDateString(dateRange.start)} - ${formatShortIsoDateString(
    dateRange.end
  )}`;
}
function getFormattedDaysFromIsoDateStringDateRange(dateRange) {
  const { start: rangeStart, end: rangeEnd } = dateRange;
  if (isIsoDateStringAfter(rangeStart, rangeEnd)) {
    throw new Error(`Date range is invalid, ${rangeStart} must be before ${rangeEnd}`);
  }
  const days = [];
  let day = rangeStart;
  while (!isIsoDateStringAfter(day, rangeEnd)) {
    days.push(formatIsoDateStringForTable(day));
    day = addToIsoDateString(day, { days: 1 });
  }
  return days;
}
function getHoursInMilliseconds(hours) {
  return hours * 3600 * 1e3;
}
function getTimeIntervalsArray(startTime, endTime, intervalMinutes) {
  const times = [];
  const [startHour, startMinute] = startTime.split(":");
  const [endHour, endMinute] = endTime.split(":");
  const startDate = /* @__PURE__ */ new Date();
  startDate.setHours(Number(startHour), Number(startMinute), 0, 0);
  const endDate = /* @__PURE__ */ new Date();
  endDate.setHours(Number(endHour), Number(endMinute), 0, 0);
  while (startDate <= endDate) {
    const hours = startDate.getHours().toString().padStart(2, "0");
    const minutes = startDate.getMinutes().toString().padStart(2, "0");
    times.push({ value: `${hours}:${minutes}`, label: `${hours}:${minutes}` });
    startDate.setMinutes(startDate.getMinutes() + intervalMinutes);
  }
  return times;
}
const ONE_SECOND_IN_MILLISECONDS = 1e3;
const ONE_MINUTE_IN_MILLISECONDS = 60 * ONE_SECOND_IN_MILLISECONDS;
const ONE_HOUR_IN_MILLISECONDS = 60 * ONE_MINUTE_IN_MILLISECONDS;
const ONE_DAY_IN_MILLISECONDS = 24 * ONE_HOUR_IN_MILLISECONDS;
const ONE_WEEK_IN_MILLISECONDS = 7 * ONE_DAY_IN_MILLISECONDS;
function extractDelimitedValues(delimitedValues) {
  return uniq(delimitedValues.split(/\s{1,}/).filter((email) => email.length));
}
function isEmailValid(email) {
  return Yup.string().email("Email valid").isValidSync(email);
}
function getInvalidEmailErrorMessage(delimitedEmails) {
  const emails = extractDelimitedValues(delimitedEmails);
  const invalidEmails = emails.filter((email) => {
    return !isEmailValid(email);
  });
  const errorCount = invalidEmails.length;
  if (!errorCount) {
    return null;
  }
  let errorMessage = `'${invalidEmails[0]}' is not a valid email`;
  if (errorCount > 1) {
    errorMessage += `, along with ${errorCount - 1} ${pluralize("other", errorCount - 1)}`;
  }
  return `${errorMessage}.`;
}
var Ethnicity = /* @__PURE__ */ ((Ethnicity2) => {
  Ethnicity2["AFRICAN_AMERICAN_BLACK"] = "African American / Black";
  Ethnicity2["ASIAN"] = "Asian";
  Ethnicity2["CAMBODIAN"] = "Cambodian";
  Ethnicity2["CHINESE"] = "Chinese";
  Ethnicity2["FILIPINO"] = "Filipino";
  Ethnicity2["INDIAN"] = "Asian Indian";
  Ethnicity2["JAPANESE"] = "Japanese";
  Ethnicity2["KOREAN"] = "Korean";
  Ethnicity2["LAOTIAN"] = "Laotian";
  Ethnicity2["VIETNAMESE"] = "Vietnamese";
  Ethnicity2["LATINO"] = "Latino/a";
  Ethnicity2["NATIVE_AMERICAN"] = "Native American";
  Ethnicity2["MIDDLE_EASTERN"] = "Middle Eastern";
  Ethnicity2["NORTH_AFRICAN"] = "North African";
  Ethnicity2["NHOP"] = "Native Hawaiian or Other Pacific Islander (NHOP)";
  Ethnicity2["GUAMANIAN"] = "Guamanian";
  Ethnicity2["HAWAIIAN"] = "Hawaiian";
  Ethnicity2["SAMOAN"] = "Samoan";
  Ethnicity2["WHITE"] = "White";
  Ethnicity2["MULTIETHNIC"] = "Multiethnic";
  Ethnicity2["OTHER"] = "Other";
  Ethnicity2["AMERICAN_INDIAN_OR_ALASKA_NATIVE"] = "American Indian or Alaska Native";
  Ethnicity2["INDIAN_ONLY"] = "Indian";
  Ethnicity2["ASIAN_PREFER_NOT_TO_SAY"] = "Asian (prefer not to say)";
  Ethnicity2["BLACK_OR_AFRICAN_AMERICAN"] = "Black or African American";
  Ethnicity2["OTHER_ASIAN"] = "Other Asian";
  Ethnicity2["MIDDLE_EASTERN_OR_NORTH_AFRICAN"] = "Middle Eastern or North African";
  Ethnicity2["MEXICAN_MEXICAN_AMERICAN_CHICANO"] = "Mexican, Mexican-American, or Chicano/a";
  Ethnicity2["CUBAN"] = "Cuban";
  Ethnicity2["PUERTO_RICAN"] = "Puerto Rican";
  Ethnicity2["OTHER_HISPANIC_OR_LATINO"] = "Other Hispanic or Latino/a";
  Ethnicity2["HISPANIC_OR_LATINO_PREFER_NOT_TO_SAY"] = "Hispanic or Latino/a (prefer not to say)";
  Ethnicity2["OTHER_PACIFIC_ISLANDER"] = "Other Pacific Islander";
  Ethnicity2["PACIFIC_ISLANDER_PREFER_NOT_TO_SAY"] = "Pacific Islander (prefer not to say)";
  Ethnicity2["OTHER_NOT_LISTED"] = "Other (not listed)";
  Ethnicity2["I_DO_NOT_KNOW"] = "I don’t know";
  Ethnicity2["PREFER_NOT_TO_ANSWER"] = "Prefer not to answer";
  return Ethnicity2;
})(Ethnicity || {});
var GENDER_IDENTITIES = /* @__PURE__ */ ((GENDER_IDENTITIES2) => {
  GENDER_IDENTITIES2["FEMALE"] = "F";
  GENDER_IDENTITIES2["MALE"] = "M";
  GENDER_IDENTITIES2["NON_BINARY"] = "non-binary";
  GENDER_IDENTITIES2["SELF_DESCRIBED"] = "self-described";
  GENDER_IDENTITIES2["PREFER_NOT_TO_RESPOND"] = "prefer not to respond";
  GENDER_IDENTITIES2["TRANS_MALE"] = "trans-male";
  GENDER_IDENTITIES2["TRANS_FEMALE"] = "trans-female";
  GENDER_IDENTITIES2["NOT_LISTED"] = "not-listed";
  return GENDER_IDENTITIES2;
})(GENDER_IDENTITIES || {});
const US_STATES = [
  { abbreviation: "AA", fullName: "Armed Forces Americas (except Canada)" },
  { abbreviation: "AE", fullName: "Armed Forces Europe, the Middle East, and Canada" },
  { abbreviation: "AL", fullName: "Alabama" },
  { abbreviation: "AK", fullName: "Alaska" },
  { abbreviation: "AS", fullName: "American Samoa" },
  { abbreviation: "AZ", fullName: "Arizona" },
  { abbreviation: "AP", fullName: "Armed Forces Pacific" },
  { abbreviation: "AR", fullName: "Arkansas" },
  { abbreviation: "CA", fullName: "California" },
  { abbreviation: "CO", fullName: "Colorado" },
  { abbreviation: "CT", fullName: "Connecticut" },
  { abbreviation: "DE", fullName: "Delaware" },
  { abbreviation: "DC", fullName: "District of Columbia" },
  { abbreviation: "FL", fullName: "Florida" },
  { abbreviation: "GA", fullName: "Georgia" },
  { abbreviation: "GU", fullName: "Guam" },
  { abbreviation: "HI", fullName: "Hawaii" },
  { abbreviation: "ID", fullName: "Idaho" },
  { abbreviation: "IL", fullName: "Illinois" },
  { abbreviation: "IN", fullName: "Indiana" },
  { abbreviation: "IA", fullName: "Iowa" },
  { abbreviation: "KS", fullName: "Kansas" },
  { abbreviation: "KY", fullName: "Kentucky" },
  { abbreviation: "LA", fullName: "Louisiana" },
  { abbreviation: "ME", fullName: "Maine" },
  { abbreviation: "MD", fullName: "Maryland" },
  { abbreviation: "MA", fullName: "Massachusetts" },
  { abbreviation: "MI", fullName: "Michigan" },
  { abbreviation: "MN", fullName: "Minnesota" },
  { abbreviation: "MS", fullName: "Mississippi" },
  { abbreviation: "MO", fullName: "Missouri" },
  { abbreviation: "MT", fullName: "Montana" },
  { abbreviation: "NE", fullName: "Nebraska" },
  { abbreviation: "NV", fullName: "Nevada" },
  { abbreviation: "NH", fullName: "New Hampshire" },
  { abbreviation: "NJ", fullName: "New Jersey" },
  { abbreviation: "NM", fullName: "New Mexico" },
  { abbreviation: "NY", fullName: "New York" },
  { abbreviation: "NC", fullName: "North Carolina" },
  { abbreviation: "ND", fullName: "North Dakota" },
  { abbreviation: "MP", fullName: "Northern Mariana Islands" },
  { abbreviation: "OH", fullName: "Ohio" },
  { abbreviation: "OK", fullName: "Oklahoma" },
  { abbreviation: "OR", fullName: "Oregon" },
  { abbreviation: "PA", fullName: "Pennsylvania" },
  { abbreviation: "PR", fullName: "Puerto Rico" },
  { abbreviation: "RI", fullName: "Rhode Island" },
  { abbreviation: "SC", fullName: "South Carolina" },
  { abbreviation: "SD", fullName: "South Dakota" },
  { abbreviation: "TN", fullName: "Tennessee" },
  { abbreviation: "TX", fullName: "Texas" },
  { abbreviation: "VI", fullName: "U.S. Virgin Islands" },
  { abbreviation: "UT", fullName: "Utah" },
  { abbreviation: "VT", fullName: "Vermont" },
  { abbreviation: "VA", fullName: "Virginia" },
  { abbreviation: "WA", fullName: "Washington" },
  { abbreviation: "WV", fullName: "West Virginia" },
  { abbreviation: "WI", fullName: "Wisconsin" },
  { abbreviation: "WY", fullName: "Wyoming" }
  /**
   * Areas that have 2-letter codes but are deliberately omitted because they are
   * outside the US: Federated States of Micronesia, Marshall Islands, and Palau.
   * Areas that are not states but are deliberately included because they are
   * part of the US: American Samoa, District of Columbia, Guam, Northern
   * Mariana Islands, Puerto Rico, Virgin Islands (U.S.).
   */
];
const US_TERRITORIES = ["AS", "GU", "MP", "PR", "VI"];
const GEOGRAPHICAL_AREAS = {
  AF: {
    name: `Afghanistan`,
    phonePrefix: `+93`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AL: {
    name: `Albania`,
    phonePrefix: `+355`,
    phoneMask: ``,
    daysToDeliver: `9`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  DZ: {
    name: `Algeria`,
    phonePrefix: `+213`,
    phoneMask: ``,
    daysToDeliver: `11`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AS: {
    name: `American Samoa`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AD: {
    name: `Andorra`,
    phonePrefix: `+376`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AO: {
    name: `Angola`,
    phonePrefix: `+244`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AI: {
    name: `Anguilla`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AQ: {
    name: `Antarctica`,
    phonePrefix: ``,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AG: {
    name: `Antigua and Barbuda`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AR: {
    name: `Argentina`,
    phonePrefix: `+54`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AM: {
    name: `Armenia`,
    phonePrefix: `+374`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9e3,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AW: {
    name: `Aruba`,
    phonePrefix: `+297`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `NL.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AU: {
    name: `Australia`,
    phonePrefix: `+61`,
    phoneMask: ``,
    daysToDeliver: `12`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Suburb`,
    cityWidth: 45,
    stateMaxlen: 3,
    stateLabel: `State Code`,
    stateWidth: 30,
    postalCodeMaxlen: 6,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 25,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AT: {
    name: `Austria`,
    phonePrefix: `+43`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AZ: {
    name: `Azerbaijan`,
    phonePrefix: `+994`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BS: {
    name: `Bahamas`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BH: {
    name: `Bahrain`,
    phonePrefix: `+973`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BD: {
    name: `Bangladesh`,
    phonePrefix: `+880`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BB: {
    name: `Barbados`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BY: {
    name: `Belarus`,
    phonePrefix: `+375`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BE: {
    name: `Belgium`,
    phonePrefix: `+32`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BZ: {
    name: `Belize`,
    phonePrefix: `+501`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BJ: {
    name: `Benin`,
    phonePrefix: `+229`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BM: {
    name: `Bermuda`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BT: {
    name: `Bhutan`,
    phonePrefix: `+975`,
    phoneMask: ``,
    daysToDeliver: `10`,
    shippingChargeCents: 9500,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BO: {
    name: `Bolivia`,
    phonePrefix: `+591`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BQ: {
    name: `Bonaire, Sint Eustatius, and Saba`,
    phonePrefix: `+599`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `NL.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BA: {
    name: `Bosnia and Herzegovina`,
    phonePrefix: `+387`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BW: {
    name: `Botswana`,
    phonePrefix: `+267`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BV: {
    name: `Bouvet Island`,
    phonePrefix: ``,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `NO.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BR: {
    name: `Brazil`,
    phonePrefix: `+55`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 80,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: 9,
    postalCodeLabel: ``,
    postalCodeWidth: 100,
    postalCodeMask: `99999-999`,
    addressFieldOrder: [[`city`, `state`], [`postalCode`], [`taxId`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: true,
    taxIdMaxlen: 18,
    taxIdLabel: `Tax ID number (CPF)`,
    taxIdWidth: 100,
    taxIdMask: `999.999.999-99`
  },
  IO: {
    name: `British Indian Ocean Territory`,
    phonePrefix: `+246`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BN: {
    name: `Brunei Darussalam`,
    phonePrefix: `+673`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BG: {
    name: `Bulgaria`,
    phonePrefix: `+359`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BF: {
    name: `Burkina Faso`,
    phonePrefix: `+226`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BI: {
    name: `Burundi`,
    phonePrefix: `+257`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CV: {
    name: `Cabo Verde`,
    phonePrefix: `+238`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KH: {
    name: `Cambodia`,
    phonePrefix: `+855`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CM: {
    name: `Cameroon`,
    phonePrefix: `+237`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CA: {
    name: `Canada`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `3`,
    shippingChargeCents: 6800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 45,
    stateMaxlen: 2,
    stateLabel: `Province`,
    stateWidth: 25,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: `A9A 9A9`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: true,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KY: {
    name: `Cayman Islands`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `3`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CF: {
    name: `Central African Republic`,
    phonePrefix: `+236`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TD: {
    name: `Chad`,
    phonePrefix: `+235`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CL: {
    name: `Chile`,
    phonePrefix: `+56`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CN: {
    name: `China`,
    phonePrefix: `+86`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 5500,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CX: {
    name: `Christmas Island`,
    phonePrefix: `+61`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CC: {
    name: `Cocos (Keeling) Islands`,
    phonePrefix: `+61`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CO: {
    name: `Colombia`,
    phonePrefix: `+57`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KM: {
    name: `Comoros`,
    phonePrefix: `+269`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CG: {
    name: `Congo`,
    phonePrefix: `+242`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CD: {
    name: `Congo (DRC)`,
    phonePrefix: `+243`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CK: {
    name: `Cook Islands`,
    phonePrefix: `+682`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9500,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Island`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `NZ.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CR: {
    name: `Costa Rica`,
    phonePrefix: `+506`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  HR: {
    name: `Croatia`,
    phonePrefix: `+385`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CU: {
    name: `Cuba`,
    phonePrefix: `+53`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CW: {
    name: `Curaçao`,
    phonePrefix: `+599`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `NL.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CY: {
    name: `Cyprus`,
    phonePrefix: `+357`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CZ: {
    name: `Czechia`,
    phonePrefix: `+420`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CI: {
    name: `Côte d'Ivoire`,
    phonePrefix: `+225`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  DK: {
    name: `Denmark`,
    phonePrefix: `+45`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  DJ: {
    name: `Djibouti`,
    phonePrefix: `+253`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  DM: {
    name: `Dominica`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `6`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  DO: {
    name: `Dominican Republic`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  EC: {
    name: `Ecuador`,
    phonePrefix: `+593`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  EG: {
    name: `Egypt`,
    phonePrefix: `+20`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SV: {
    name: `El Salvador`,
    phonePrefix: `+503`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GQ: {
    name: `Equatorial Guinea`,
    phonePrefix: `+240`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ER: {
    name: `Eritrea`,
    phonePrefix: `+291`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  EE: {
    name: `Estonia`,
    phonePrefix: `+372`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SZ: {
    name: `Eswatini`,
    phonePrefix: `+268`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ET: {
    name: `Ethiopia`,
    phonePrefix: `+251`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  FK: {
    name: `Falkland Islands (Malvinas)`,
    phonePrefix: `+500`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 7200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  FO: {
    name: `Faroe Islands`,
    phonePrefix: `+298`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `DK.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  FJ: {
    name: `Fiji`,
    phonePrefix: `+679`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  FI: {
    name: `Finland`,
    phonePrefix: `+358`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  FR: {
    name: `France`,
    phonePrefix: `+33`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GF: {
    name: `French Guiana`,
    phonePrefix: `+594`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 7200,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PF: {
    name: `French Polynesia`,
    phonePrefix: `+689`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TF: {
    name: `French Southern Territories`,
    phonePrefix: ``,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GA: {
    name: `Gabon`,
    phonePrefix: `+241`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GM: {
    name: `Gambia`,
    phonePrefix: `+220`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GE: {
    name: `Georgia`,
    phonePrefix: `+995`,
    phoneMask: ``,
    daysToDeliver: `8`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  DE: {
    name: `Germany`,
    phonePrefix: `+49`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 80,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 20,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GH: {
    name: `Ghana`,
    phonePrefix: `+233`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GI: {
    name: `Gibraltar`,
    phonePrefix: `+350`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GR: {
    name: `Greece`,
    phonePrefix: `+30`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GL: {
    name: `Greenland`,
    phonePrefix: `+299`,
    phoneMask: ``,
    daysToDeliver: `8`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `DK.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GD: {
    name: `Grenada`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GP: {
    name: `Guadeloupe`,
    phonePrefix: `+590`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6300,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GU: {
    name: `Guam`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GT: {
    name: `Guatemala`,
    phonePrefix: `+502`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GG: {
    name: `Guernsey`,
    phonePrefix: `+44`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GN: {
    name: `Guinea`,
    phonePrefix: `+224`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GW: {
    name: `Guinea Bissau`,
    phonePrefix: `+245`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GY: {
    name: `Guyana`,
    phonePrefix: `+592`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  HT: {
    name: `Haiti`,
    phonePrefix: `+509`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  HM: {
    name: `Heard Island and McDonald Islands`,
    phonePrefix: ``,
    phoneMask: ``,
    daysToDeliver: `12`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Suburb`,
    cityWidth: 45,
    stateMaxlen: 3,
    stateLabel: `State Code`,
    stateWidth: 30,
    postalCodeMaxlen: 6,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 25,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `AU.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VA: {
    name: `Holy See (Vatican City State)`,
    phonePrefix: `+379`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  HN: {
    name: `Honduras`,
    phonePrefix: `+504`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  HK: {
    name: `Hong Kong`,
    phonePrefix: `+852`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 7100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Village, Town, or District`,
    cityWidth: ``,
    stateMaxlen: 15,
    stateLabel: `Part of Hong Kong`,
    stateWidth: 40,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: 0,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`state`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  HU: {
    name: `Hungary`,
    phonePrefix: `+36`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IS: {
    name: `Iceland`,
    phonePrefix: `+354`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IN: {
    name: `India`,
    phonePrefix: `+91`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 5800,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ID: {
    name: `Indonesia`,
    phonePrefix: `+62`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IR: {
    name: `Iran`,
    phonePrefix: `+98`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IQ: {
    name: `Iraq`,
    phonePrefix: `+964`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 9e3,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IE: {
    name: `Ireland`,
    phonePrefix: `+353`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Postal Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IM: {
    name: `Isle of Man`,
    phonePrefix: `+44`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IL: {
    name: `Israel`,
    phonePrefix: `+972`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 7,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  IT: {
    name: `Italy`,
    phonePrefix: `+39`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: 45,
    stateMaxlen: 2,
    stateLabel: `Province`,
    stateWidth: 25,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`, `state`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  JM: {
    name: `Jamaica`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  JP: {
    name: `Japan`,
    phonePrefix: `+81`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  JE: {
    name: `Jersey`,
    phonePrefix: `+44`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  JO: {
    name: `Jordan`,
    phonePrefix: `+962`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KZ: {
    name: `Kazakhstan`,
    phonePrefix: `+7`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KE: {
    name: `Kenya`,
    phonePrefix: `+254`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KI: {
    name: `Kiribati`,
    phonePrefix: `+686`,
    phoneMask: ``,
    daysToDeliver: `8`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  XK: {
    name: `Kosovo`,
    phonePrefix: `+383`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KW: {
    name: `Kuwait`,
    phonePrefix: `+965`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KG: {
    name: `Kyrgyzstan`,
    phonePrefix: `+996`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LA: {
    name: `Laos`,
    phonePrefix: `+856`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LV: {
    name: `Latvia`,
    phonePrefix: `+371`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LB: {
    name: `Lebanon`,
    phonePrefix: `+961`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 9e3,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LS: {
    name: `Lesotho`,
    phonePrefix: `+266`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LR: {
    name: `Liberia`,
    phonePrefix: `+231`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LY: {
    name: `Libya`,
    phonePrefix: `+218`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LI: {
    name: `Liechtenstein`,
    phonePrefix: `+423`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LT: {
    name: `Lithuania`,
    phonePrefix: `+370`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LU: {
    name: `Luxembourg`,
    phonePrefix: `+352`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MO: {
    name: `Macau`,
    phonePrefix: `+853`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 5800,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `CN.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MG: {
    name: `Madagascar`,
    phonePrefix: `+261`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MW: {
    name: `Malawi`,
    phonePrefix: `+265`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MY: {
    name: `Malaysia`,
    phonePrefix: `+60`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MV: {
    name: `Maldives`,
    phonePrefix: `+960`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ML: {
    name: `Mali`,
    phonePrefix: `+223`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MT: {
    name: `Malta`,
    phonePrefix: `+356`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MH: {
    name: `Marshall Islands`,
    phonePrefix: `+692`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MQ: {
    name: `Martinique`,
    phonePrefix: `+596`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6300,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MR: {
    name: `Mauritania`,
    phonePrefix: `+222`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MU: {
    name: `Mauritius`,
    phonePrefix: `+230`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  YT: {
    name: `Mayotte`,
    phonePrefix: `+262`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MX: {
    name: `Mexico`,
    phonePrefix: `+52`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 4500,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 50,
    stateMaxlen: 5,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`postalCode`, `city`, `state`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  FM: {
    name: `Micronesia`,
    phonePrefix: `+691`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MD: {
    name: `Moldova`,
    phonePrefix: `+373`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MC: {
    name: `Monaco`,
    phonePrefix: `+377`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MN: {
    name: `Mongolia`,
    phonePrefix: `+976`,
    phoneMask: ``,
    daysToDeliver: `9`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ME: {
    name: `Montenegro`,
    phonePrefix: `+382`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MS: {
    name: `Montserrat`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MA: {
    name: `Morocco`,
    phonePrefix: `+212`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MZ: {
    name: `Mozambique`,
    phonePrefix: `+258`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MM: {
    name: `Myanmar`,
    phonePrefix: `+95`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NA: {
    name: `Namibia`,
    phonePrefix: `+264`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NR: {
    name: `Nauru`,
    phonePrefix: `+674`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NP: {
    name: `Nepal`,
    phonePrefix: `+977`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NL: {
    name: `Netherlands`,
    phonePrefix: `+31`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NC: {
    name: `New Caledonia`,
    phonePrefix: `+687`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 9500,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NZ: {
    name: `New Zealand`,
    phonePrefix: `+64`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NI: {
    name: `Nicaragua`,
    phonePrefix: `+505`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NE: {
    name: `Niger`,
    phonePrefix: `+227`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NG: {
    name: `Nigeria`,
    phonePrefix: `+234`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NU: {
    name: `Niue`,
    phonePrefix: `+683`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `NZ.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NF: {
    name: `Norfolk Island`,
    phonePrefix: `+672`,
    phoneMask: ``,
    daysToDeliver: `12`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Suburb`,
    cityWidth: 45,
    stateMaxlen: 3,
    stateLabel: `State Code`,
    stateWidth: 30,
    postalCodeMaxlen: 6,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 25,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `AU.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KP: {
    name: `North Korea`,
    phonePrefix: `+850`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MK: {
    name: `North Macedonia`,
    phonePrefix: `+389`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MP: {
    name: `Northern Mariana Islands`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  NO: {
    name: `Norway`,
    phonePrefix: `+47`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  OM: {
    name: `Oman`,
    phonePrefix: `+968`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PK: {
    name: `Pakistan`,
    phonePrefix: `+92`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PW: {
    name: `Palau`,
    phonePrefix: `+680`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PS: {
    name: `Palestine`,
    phonePrefix: `+970`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PA: {
    name: `Panama`,
    phonePrefix: `+507`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PG: {
    name: `Papua New Guinea`,
    phonePrefix: `+675`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PY: {
    name: `Paraguay`,
    phonePrefix: `+595`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PE: {
    name: `Peru`,
    phonePrefix: `+51`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PH: {
    name: `Philippines`,
    phonePrefix: `+63`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PN: {
    name: `Pitcairn`,
    phonePrefix: `+64`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PL: {
    name: `Poland`,
    phonePrefix: `+48`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PT: {
    name: `Portugal`,
    phonePrefix: `+351`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PR: {
    name: `Puerto Rico`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  QA: {
    name: `Qatar`,
    phonePrefix: `+974`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  RO: {
    name: `Romania`,
    phonePrefix: `+40`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  RU: {
    name: `Russian Federation`,
    phonePrefix: `+7`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  RW: {
    name: `Rwanda`,
    phonePrefix: `+250`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  RE: {
    name: `Réunion`,
    phonePrefix: `+262`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  BL: {
    name: `Saint Barthélemy`,
    phonePrefix: `+590`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SH: {
    name: `Saint Helena, Ascension and Tristan da Cunha`,
    phonePrefix: `+290`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KN: {
    name: `Saint Kitts and Nevis`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LC: {
    name: `Saint Lucia`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  MF: {
    name: `Saint Martin (French part)`,
    phonePrefix: `+590`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  PM: {
    name: `Saint Pierre and Miquelon`,
    phonePrefix: `+508`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VC: {
    name: `Saint Vincent and the Grenadines`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `5`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  WS: {
    name: `Samoa`,
    phonePrefix: `+685`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SM: {
    name: `San Marino`,
    phonePrefix: `+378`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ST: {
    name: `Sao Tome and Principe`,
    phonePrefix: `+239`,
    phoneMask: ``,
    daysToDeliver: `8`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SA: {
    name: `Saudi Arabia`,
    phonePrefix: `+966`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9e3,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SN: {
    name: `Senegal`,
    phonePrefix: `+221`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  RS: {
    name: `Serbia`,
    phonePrefix: `+381`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SC: {
    name: `Seychelles`,
    phonePrefix: `+248`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SL: {
    name: `Sierra Leone`,
    phonePrefix: `+232`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SG: {
    name: `Singapore`,
    phonePrefix: `+65`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 6,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SX: {
    name: `Sint Maarten (Dutch part)`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `NL.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SK: {
    name: `Slovakia`,
    phonePrefix: `+421`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SI: {
    name: `Slovenia`,
    phonePrefix: `+386`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SB: {
    name: `Solomon Islands`,
    phonePrefix: `+677`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SO: {
    name: `Somalia`,
    phonePrefix: `+252`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ZA: {
    name: `South Africa`,
    phonePrefix: `+27`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GS: {
    name: `South Georgia and the South Sandwich Islands`,
    phonePrefix: `+500`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  KR: {
    name: `South Korea`,
    phonePrefix: `+82`,
    phoneMask: ``,
    daysToDeliver: `8`,
    shippingChargeCents: 7800,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SS: {
    name: `South Sudan`,
    phonePrefix: `+211`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ES: {
    name: `Spain`,
    phonePrefix: `+34`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 8200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: 40,
    stateMaxlen: 30,
    stateLabel: `Province`,
    stateWidth: 30,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`, `state`]],
    addressOptionalFields: [`state`],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  LK: {
    name: `Sri Lanka`,
    phonePrefix: `+94`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SD: {
    name: `Sudan`,
    phonePrefix: `+249`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SR: {
    name: `Suriname`,
    phonePrefix: `+597`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SJ: {
    name: `Svalbard and Jan Mayen`,
    phonePrefix: `+47`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: `NO.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SE: {
    name: `Sweden`,
    phonePrefix: `+46`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  CH: {
    name: `Switzerland`,
    phonePrefix: `+41`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  SY: {
    name: `Syria`,
    phonePrefix: `+963`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TW: {
    name: `Taiwan`,
    phonePrefix: `+886`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 7100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TJ: {
    name: `Tajikistan`,
    phonePrefix: `+992`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TZ: {
    name: `Tanzania`,
    phonePrefix: `+255`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TH: {
    name: `Thailand`,
    phonePrefix: `+66`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TL: {
    name: `Timor-Leste`,
    phonePrefix: `+670`,
    phoneMask: ``,
    daysToDeliver: `10`,
    shippingChargeCents: 9500,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TG: {
    name: `Togo`,
    phonePrefix: `+228`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TK: {
    name: `Tokelau`,
    phonePrefix: `+690`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 4,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `NZ.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TO: {
    name: `Tonga`,
    phonePrefix: `+676`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TT: {
    name: `Trinidad and Tobago`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TN: {
    name: `Tunisia`,
    phonePrefix: `+216`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 11400,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TM: {
    name: `Turkmenistan`,
    phonePrefix: `+993`,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TC: {
    name: `Turks and Caicos Islands`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TV: {
    name: `Tuvalu`,
    phonePrefix: `+688`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  TR: {
    name: `Türkiye`,
    phonePrefix: `+90`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  UG: {
    name: `Uganda`,
    phonePrefix: `+256`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  UA: {
    name: `Ukraine`,
    phonePrefix: `+380`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 10900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AE: {
    name: `United Arab Emirates`,
    phonePrefix: `+971`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9800,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  GB: {
    name: `United Kingdom`,
    phonePrefix: `+44`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  US: {
    name: `United States`,
    phonePrefix: `+1`,
    phoneMask: `(999) 999-9999`,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: ``,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  UM: {
    name: `United States Minor Outlying Islands`,
    phonePrefix: ``,
    phoneMask: ``,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  UY: {
    name: `Uruguay`,
    phonePrefix: `+598`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 8100,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  UZ: {
    name: `Uzbekistan`,
    phonePrefix: `+998`,
    phoneMask: ``,
    daysToDeliver: `7`,
    shippingChargeCents: 10700,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VU: {
    name: `Vanuatu`,
    phonePrefix: `+678`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9500,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VE: {
    name: `Venezuela`,
    phonePrefix: `+58`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 7200,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VN: {
    name: `Viet Nam`,
    phonePrefix: `+84`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 7900,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VG: {
    name: `Virgin Islands, British`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6600,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `Town`,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 8,
    postalCodeLabel: `Postcode`,
    postalCodeWidth: 100,
    postalCodeMask: ``,
    addressFieldOrder: [[`city`], [`postalCode`]],
    addressOptionalFields: [],
    flagFilename: `GB.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  VI: {
    name: `Virgin Islands, U.S.`,
    phonePrefix: `+1`,
    phoneMask: ``,
    daysToDeliver: `2-6`,
    shippingChargeCents: 995,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: `City`,
    cityWidth: 55,
    stateMaxlen: 2,
    stateLabel: `State`,
    stateWidth: 20,
    postalCodeMaxlen: ``,
    postalCodeLabel: `Zip Code`,
    postalCodeWidth: 25,
    postalCodeMask: `99999`,
    addressFieldOrder: [[`city`, `state`, `postalCode`]],
    addressOptionalFields: [],
    flagFilename: `US.png`,
    outboundShipperName: `USPS`,
    outboundServiceName: `First-class Mail`,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  WF: {
    name: `Wallis and Futuna`,
    phonePrefix: `+681`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 6100,
    ourGovtOk: ``,
    theirGovtOk: false,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Town Name and Sorting Code`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FR.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  EH: {
    name: `Western Sahara`,
    phonePrefix: ``,
    phoneMask: ``,
    daysToDeliver: ``,
    shippingChargeCents: ``,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  YE: {
    name: `Yemen`,
    phonePrefix: `+967`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 9e3,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ZM: {
    name: `Zambia`,
    phonePrefix: `+260`,
    phoneMask: ``,
    daysToDeliver: `6`,
    shippingChargeCents: 12200,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  ZW: {
    name: `Zimbabwe`,
    phonePrefix: `+263`,
    phoneMask: ``,
    daysToDeliver: `5`,
    shippingChargeCents: 11400,
    ourGovtOk: false,
    theirGovtOk: ``,
    carrierOk: ``,
    cityMaxlen: ``,
    cityLabel: ``,
    cityWidth: ``,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: ``,
    postalCodeMaxlen: ``,
    postalCodeLabel: ``,
    postalCodeWidth: ``,
    postalCodeMask: ``,
    addressFieldOrder: ``,
    addressOptionalFields: ``,
    flagFilename: ``,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  },
  AX: {
    name: `Åland Islands`,
    phonePrefix: `+358`,
    phoneMask: ``,
    daysToDeliver: `4`,
    shippingChargeCents: 9300,
    ourGovtOk: ``,
    theirGovtOk: ``,
    carrierOk: false,
    cityMaxlen: ``,
    cityLabel: `Settlement`,
    cityWidth: 70,
    stateMaxlen: ``,
    stateLabel: ``,
    stateWidth: 0,
    postalCodeMaxlen: 5,
    postalCodeLabel: ``,
    postalCodeWidth: 30,
    postalCodeMask: ``,
    addressFieldOrder: [[`postalCode`, `city`]],
    addressOptionalFields: [],
    flagFilename: `FI.png`,
    outboundShipperName: ``,
    outboundServiceName: ``,
    deliveredDutyPaid: ``,
    taxIdMaxlen: ``,
    taxIdLabel: ``,
    taxIdWidth: ``,
    taxIdMask: ``
  }
};
const defaultAddressFieldOrder = [[`city`], [`state`, `postalCode`]];
const defaultAddressOptionalFields = [`state`, `postalCode`];
const getName = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.name || null;
};
const getPhonePrefix = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.phonePrefix || null;
};
const getPhoneMask = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.phoneMask || null;
};
const getDaysToDeliver = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.daysToDeliver || null;
};
const getShippingChargeCents = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.shippingChargeCents || null;
};
const getOurGovtOk = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.ourGovtOk || true;
};
const getTheirGovtOk = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.theirGovtOk || true;
};
const getCarrierOk = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.carrierOk || true;
};
const getCityMaxlen = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.cityMaxlen || 80;
};
const getCityLabel = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.cityLabel || `City, Town, or Settlement`;
};
const getCityWidth = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.cityWidth || 100;
};
const getStateMaxlen = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.stateMaxlen || 50;
};
const getStateLabel = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.stateLabel || `State, Province, or Region`;
};
const getStateWidth = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.stateWidth || 60;
};
const getPostalCodeMaxlen = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeMaxlen || 10;
};
const getPostalCodeLabel = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeLabel || `Postal Code`;
};
const getPostalCodeWidth = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.postalCodeWidth || 40;
};
const getAddressFieldOrder = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.addressFieldOrder || defaultAddressFieldOrder;
};
const getAddressOptionalFields = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.addressOptionalFields || defaultAddressOptionalFields;
};
const getFlagFilename = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.flagFilename || `${countryCode}.png`;
};
const getOutboundShipperName = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.outboundShipperName || `DHL`;
};
const getOutboundServiceName = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.outboundServiceName || `Express Worldwide`;
};
const getTaxIdMaxlen = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.taxIdMaxlen || null;
};
const getTaxIdWidth = (countryCode) => {
  return GEOGRAPHICAL_AREAS[countryCode]?.taxIdWidth || null;
};
const getFieldWidth = (countryCode, field) => {
  if (field === "city") {
    return getCityWidth(countryCode);
  }
  if (field === "state") {
    return getStateWidth(countryCode);
  }
  if (field === "postalCode") {
    return getPostalCodeWidth(countryCode);
  }
  if (field === "taxId") {
    return getTaxIdWidth(countryCode);
  }
  return void 0;
};
const isCountryShippable = (countryCode) => {
  return getOurGovtOk(countryCode) && getTheirGovtOk(countryCode) && getCarrierOk(countryCode);
};
const hasAddressFieldForCountry = (countryCode, fieldName) => {
  const fieldOrder = getAddressFieldOrder(countryCode);
  const flattenedFields = [...fieldOrder];
  return flattenedFields.indexOf(fieldName) !== -1;
};
const isRequiredFieldForCountryAddress = (countryCode, fieldName) => {
  const optionalFields = getAddressOptionalFields(countryCode);
  return optionalFields.indexOf(fieldName) === -1;
};
const ALL_COUNTRIES = Object.keys(GEOGRAPHICAL_AREAS).filter((countryCode) => {
  return getOurGovtOk(countryCode) && getCarrierOk(countryCode);
}).sort((a, b) => {
  return getName(a).localeCompare(getName(b));
});
const PHONE_COUNTRIES = Object.keys(GEOGRAPHICAL_AREAS).filter((countryCode) => {
  return getPhonePrefix(countryCode);
}).sort((a, b) => {
  return getName(a).localeCompare(getName(b));
});
function navigateAndRefreshBrowser(url) {
  window.location.assign(url);
}
function openNewBrowserTab(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}
function scrollIntoView(element, options) {
  const doesScrollIntoViewExist = Boolean(element.scrollIntoView);
  element.focus?.({ preventScroll: doesScrollIntoViewExist });
  if (doesScrollIntoViewExist) {
    element.scrollIntoView(options);
  }
}
const RedirectWithNextParam = (props) => {
  const { redirectPath } = props;
  const { search } = useLocation();
  const newSearchQuery = toQueryString({
    next: getSafeNextQueryParam(search) ?? getCurrentPath()
  });
  return /* @__PURE__ */ jsx(
    Redirect,
    {
      to: {
        pathname: redirectPath,
        search: newSearchQuery
      }
    }
  );
};
const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_BETTER_LENGTH = 10;
const getPasswordStrength = (password = "") => {
  const hasMinLength = password.length >= PASSWORD_MIN_LENGTH;
  const hasBetterLength = password.length >= PASSWORD_BETTER_LENGTH;
  const minLengthScore = hasMinLength ? 1 : 0;
  const betterLengthScore = hasBetterLength ? 1 : 0;
  const hasNonAlphas = Boolean(password.match(/[^a-zA-Z]/));
  const hasMixedCase = Boolean(password.match(/[a-z]/)) && Boolean(password.match(/[A-Z]/));
  const nonAlphaScore = hasNonAlphas ? 1 : 0;
  const mixedCaseScore = hasMixedCase ? 1 : 0;
  const intermediateScore = 8 * minLengthScore + 4 * nonAlphaScore + 2 * mixedCaseScore + betterLengthScore;
  let scaledScore = 0;
  if (intermediateScore >= 15) {
    scaledScore = 4;
  } else if (intermediateScore >= 14) {
    scaledScore = 3;
  } else if (intermediateScore >= 12) {
    scaledScore = 2;
  } else if (intermediateScore >= 8) {
    scaledScore = 1;
  }
  return {
    hasMinLength,
    hasMixedCase,
    hasNonAlphas,
    scaledScore
  };
};
const E164_REGEX = /^\+(1|2(?:0|1[12368]|2\d|3\d|4\d|5[0-8]|6\d|7|9[01789])|3(?:[0-4]|5\d|6|7[0-8]|8[0125679]|9)|4(?:0|1|2[013]|[3-9])|5(?:0\d|[1-8]|9\d)|6(?:[0-6]|7[023456789]|8[012356789]|9[012])|7|8(?:0[08]|1|2|4|5[02356]|6|7[08]|8[012368])|9(?:[0-4]|5|6[0-8]|7[012345679]|8|9[234568]))(\d+)(?:;ext=(\d+))?$/;
const getFormattedE164Number = (e164Match) => {
  const [, country, number, extension] = e164Match;
  let formattedNumber;
  if (country === "1" && number?.length === 10) {
    formattedNumber = `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
  } else {
    formattedNumber = `+${country} ${number}`;
  }
  if (extension) {
    formattedNumber += ` ext. ${extension}`;
  }
  return formattedNumber;
};
const formatPhoneNumber = (telephoneNumber) => {
  if (!telephoneNumber) {
    return "";
  }
  let number;
  let extension;
  let formattedNumber;
  if (isInstanceOfIPhoneNumber(telephoneNumber)) {
    number = telephoneNumber.national_number;
    if (!number) {
      return "";
    }
    const prefix = getPhonePrefix(telephoneNumber.country);
    extension = telephoneNumber.extension;
    formattedNumber = prefix + number;
    if (extension) {
      formattedNumber += `;ext=${extension}`;
    }
  } else {
    formattedNumber = telephoneNumber;
  }
  const e164Match = E164_REGEX.exec(formattedNumber);
  if (e164Match) {
    return getFormattedE164Number(e164Match);
  }
  const value = formattedNumber.toString().trim().replace(/[\+\-()\s]/g, "");
  if (value.match(/[^0-9]/)) {
    return formattedNumber;
  }
  let city;
  switch (value.length) {
    // Assumes US/Canada +1 telephone numbers
    // To handle more cases up to 15 digits, refer to https://en.wikipedia.org/wiki/List_of_country_calling_codes
    case 10:
      city = value.slice(0, 3);
      number = value.slice(3);
      break;
    case 11:
      city = value.slice(1, 4);
      number = value.slice(4);
      break;
    default:
      return formattedNumber;
  }
  number = `${number.slice(0, 3)}-${number.slice(3)}`;
  const formattedNumberWithCity = `(${city}) ${number}`.trim();
  if (extension) {
    return `${formattedNumberWithCity} ext. ${extension}`;
  }
  return formattedNumberWithCity;
};
function getDefaultPhoneNumber() {
  return {
    country: "US",
    national_number: "",
    extension: ""
  };
}
function isInstanceOfIPhoneNumber(object) {
  return typeof object === "object" && object !== null && "country" in object && "national_number" in object;
}
function parsePhoneNumber(phoneNumber) {
  let formattedPhoneNumber = typeof phoneNumber === "string" ? phoneNumber.trim() : "";
  if (formattedPhoneNumber && !formattedPhoneNumber.startsWith("+")) {
    formattedPhoneNumber = `+1${formattedPhoneNumber}`;
  }
  let phoneCountry = "US";
  let phonePrefix = "";
  let phoneNatlNumber = "";
  let phoneExtension = "";
  const countryIsUS = formattedPhoneNumber.startsWith("+1");
  const matched = E164_REGEX.exec(formattedPhoneNumber);
  if (matched) {
    [, phonePrefix = "", phoneNatlNumber = "", phoneExtension] = matched;
    const matchedCountryPrefix = `+${phonePrefix}`;
    phoneCountry = first(
      ALL_COUNTRIES.filter((country) => getPhonePrefix(country) === matchedCountryPrefix)
    ) || "US";
  }
  if (countryIsUS) {
    phoneCountry = "US";
  }
  return {
    country: phoneCountry,
    national_number: phoneNatlNumber,
    extension: phoneExtension
  };
}
function formatAsE164(phoneNumber) {
  return `${getPhonePrefix(phoneNumber.country)}${phoneNumber.national_number}${phoneNumber.extension ? `;ext=${phoneNumber.extension}` : ""}`;
}
const MASK_DEFINITIONS = {
  "9": /\d/
};
function uiMaskToTextMask(uiMask) {
  return Array.from(uiMask).map((c) => MASK_DEFINITIONS[c] ?? c);
}
function formatPhoneNumberWithMask(phoneNumber) {
  const countryPhoneMask = getPhoneMask(phoneNumber.country);
  const mask = countryPhoneMask ? uiMaskToTextMask(countryPhoneMask) : void 0;
  const prefix = getPhonePrefix(phoneNumber.country);
  const maskedContent = mask ? conformToMask(phoneNumber.national_number, mask).conformedValue : phoneNumber.national_number;
  if (!prefix) {
    return maskedContent;
  }
  return `${prefix} ${maskedContent}`;
}
function PhoneNumberFactory(extraProps) {
  return {
    country: "US",
    national_number: "9876543210",
    ...extraProps
  };
}
const RETRY_OPTIONS = {
  // retries means N tries after the first time, for a total of N + 1 attempts
  retries: 4,
  minTimeout: 200
};
async function retry(resolver, options = {}) {
  return asyncRetry(resolver, { ...RETRY_OPTIONS, ...options });
}
var SexAssignedAtBirth = /* @__PURE__ */ ((SexAssignedAtBirth2) => {
  SexAssignedAtBirth2["FEMALE"] = "F";
  SexAssignedAtBirth2["MALE"] = "M";
  return SexAssignedAtBirth2;
})(SexAssignedAtBirth || {});
var GenderIdentity = /* @__PURE__ */ ((GenderIdentity2) => {
  GenderIdentity2["WOMAN"] = "Female/woman";
  GenderIdentity2["MAN"] = "Male/man";
  GenderIdentity2["TRANS_WOMAN"] = "Transgender female/woman";
  GenderIdentity2["TRANS_MAN"] = "Transgender male/man";
  GenderIdentity2["NONBINARY_GENDERQUEER"] = "Nonbinary, genderqueer, or not exclusively female or male";
  GenderIdentity2["ANOTHER_GENDER"] = "Another gender";
  GenderIdentity2["DO_NOT_KNOW"] = "Don't know";
  GenderIdentity2["PREFER_NOT_TO_SAY"] = "Prefer not to say";
  return GenderIdentity2;
})(GenderIdentity || {});
var GenderIdentityDataSharingRequirement = /* @__PURE__ */ ((GenderIdentityDataSharingRequirement2) => {
  GenderIdentityDataSharingRequirement2[GenderIdentityDataSharingRequirement2["SENT_TO_EXTERNAL_EMR"] = 0] = "SENT_TO_EXTERNAL_EMR";
  GenderIdentityDataSharingRequirement2[GenderIdentityDataSharingRequirement2["SENT_TO_STATE_FEDERAL_DASHBOARD"] = 1] = "SENT_TO_STATE_FEDERAL_DASHBOARD";
  GenderIdentityDataSharingRequirement2[GenderIdentityDataSharingRequirement2["SHARED_WITH_CLINICIAN_WHEN_APPROPRIATE"] = 2] = "SHARED_WITH_CLINICIAN_WHEN_APPROPRIATE";
  return GenderIdentityDataSharingRequirement2;
})(GenderIdentityDataSharingRequirement || {});
const SEX_ASSIGNED_AT_BIRTH_FIELD_NAME = "sex";
const GENDER_IDENTITY_FIELD_NAME = "genderIdentity";
const ANOTHER_GENDER_FIELD_NAME = "selfDescribedGenderIdentity";
const SEXUAL_ORIENTATION_FIELD_NAME = "sexualOrientation";
const NOT_LISTED_FIELD_NAME = "selfDescribedSexualOrientation";
const GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = {
  genderIdentityFieldName: GENDER_IDENTITY_FIELD_NAME,
  anotherGenderFieldName: ANOTHER_GENDER_FIELD_NAME
};
var SexualOrientationIdentity = /* @__PURE__ */ ((SexualOrientationIdentity2) => {
  SexualOrientationIdentity2["LESBIAN_OR_GAY"] = "Lesbian or gay";
  SexualOrientationIdentity2["STRAIGHT_OR_HETEROSEXUAL"] = "Straight or heterosexual";
  SexualOrientationIdentity2["BISEXUAL"] = "Bisexual";
  SexualOrientationIdentity2["QUEER"] = "Queer";
  SexualOrientationIdentity2["ASEXUAL"] = "Asexual";
  SexualOrientationIdentity2["PANSEXUAL"] = "Pansexual";
  SexualOrientationIdentity2["DO_NOT_KNOW"] = "Don't know";
  SexualOrientationIdentity2["PREFER_NOT_TO_SAY"] = "Prefer not to say";
  SexualOrientationIdentity2["NOT_LISTED"] = "Not Listed";
  return SexualOrientationIdentity2;
})(SexualOrientationIdentity || {});
const SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES = {
  sexAssignedAtBirthFieldName: SEX_ASSIGNED_AT_BIRTH_FIELD_NAME,
  ...GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES
};
const GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = {
  genderIdentityFieldName: snakeCase(GENDER_IDENTITY_FIELD_NAME),
  anotherGenderFieldName: snakeCase(ANOTHER_GENDER_FIELD_NAME)
};
const SEX_AND_GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES = {
  sexAssignedAtBirthFieldName: snakeCase(SEX_ASSIGNED_AT_BIRTH_FIELD_NAME),
  ...GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES
};
const SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES = {
  sexualOrientationFieldName: SEXUAL_ORIENTATION_FIELD_NAME,
  notListedFieldName: NOT_LISTED_FIELD_NAME
};
const SEXUAL_ORIENTATION_SNAKE_CASE_FIELD_NAMES = {
  sexualOrientationFieldName: snakeCase(SEXUAL_ORIENTATION_FIELD_NAME),
  notListedFieldName: snakeCase(NOT_LISTED_FIELD_NAME)
};
function isObjKey(key, obj) {
  return key in obj;
}
var GroupType = /* @__PURE__ */ ((GroupType2) => {
  GroupType2["CARE_ADVOCATE"] = "Care Advocates";
  GroupType2["TELEPREP_ENROLLMENT_WORKERS"] = "CDPH TelePrEP/PEP Enrollment Workers";
  GroupType2["TELEPREP_PHYSICIANS"] = "CDPH TelePrEP/PEP Clinicians";
  GroupType2["LAB_ORDER_REQUEST_REVIEWERS"] = "Lab Order Request Reviewers";
  GroupType2["CANCER_BETA_CLINICIANS"] = "Cancer Beta Clinicians";
  GroupType2["CANCER_CARDIO_SCREENING_PILOT_CLINICIANS"] = "Cancer-Cardio Screening Pilot Clinicians";
  GroupType2["COOK_COUNTY_STI_CLINICIANS"] = "Cook County STI Clinicians";
  GroupType2["MEDOPS"] = "MedOps";
  GroupType2["LAB_RESULTS"] = "Lab Results";
  GroupType2["REFERRAL_COORDINATION"] = "Referral Coordination";
  GroupType2["GENETIC_COUNSELORS"] = "Genetic Counselors";
  GroupType2["COVID"] = "COVID-19";
  GroupType2["MEDOPS_TELEPREP"] = "MedOps TelePrEP";
  GroupType2["RISK_REVIEW_EXPERTS"] = "Risk Review Experts";
  GroupType2["CANCER_CONNECT_LEADERS"] = "Cancer Connect Leaders";
  GroupType2["CANCER_SURVIVORSHIP_CLINICIANS"] = "Cancer Survivorship Clinicians";
  GroupType2["IMAGE_ORDER_REQUEST_REVIEWERS"] = "Image Order Request Reviewers";
  GroupType2["IMAGE_RESULTS"] = "Image Results";
  GroupType2["IN_TREATMENT_CANCER_CLINICIANS"] = "In-treatment Cancer Clinicians";
  GroupType2["ONCOLOGY_NURSES"] = "Oncology Nurses";
  GroupType2["CLINICAL_CARE_TEAM"] = "Clinical Care Team";
  GroupType2["REGISTERED_DIETITIANS"] = "Registered Dietitians";
  GroupType2["CANCER_PREVENTION_SERVICES_CLINICIANS"] = "Clinicians - Cancer Prevention Services";
  GroupType2["CANCER_SURVIVORSHIP_SERVICES_CLINICIANS"] = "Clinicians - Cancer Survivorship Services";
  GroupType2["CANCER_ACTIVE_TREATMENT_SERVICES_CLINICIANS"] = "Clinicians - Cancer Active Treatment Services";
  GroupType2["CANCER_RISK_EXPERTS"] = "Cancer Risk Experts";
  GroupType2["REFERRAL_COORDINATORS"] = "Referral Coordinators";
  GroupType2["SUPPORT"] = "Support";
  return GroupType2;
})(GroupType || {});
export {
  ADULT_MINIMUM_AGE,
  ALL_COUNTRIES,
  ALL_LOCALES,
  ALL_USER_ROLES,
  ANOTHER_GENDER_FIELD_NAME,
  AddressFactory,
  ApiClient,
  ApiError,
  AuthProvider,
  BrowserStorageType,
  CANCER_TEST_TYPES,
  COLOR_ISO_639_CODE_BY_LOCALE,
  COVID_TEST_TYPES,
  CollectionSiteRole,
  CollectionSiteRoleCategory,
  ColorIso639Code,
  CookiesProvider,
  DATE_FNS_LOCALES,
  DEFAULT_LOCALE,
  DJANGO_TO_FRONTEND_LOCALES,
  ESSENTIAL_CARE_TEST_TYPES,
  Environment,
  Ethnicity,
  ExtraLocale,
  FRONTEND_TO_DJANGO_LOCALES,
  FakeLaunchDarklyFlagContextProvider,
  FeatureFlagProviderHoc,
  GENDER_IDENTITIES,
  GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES,
  GENDER_IDENTITY_FIELD_NAME,
  GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES,
  GENETICS_USER_ROLES,
  GENETIC_TEST_TYPES,
  GenderIdentity,
  GenderIdentityDataSharingRequirement,
  GroupType,
  INDEPENDENT_MINOR_MINIMUM_AGE,
  KitOrderStatus,
  KitOrderTestType,
  LOCALE_DISPLAY_NAMES,
  LOCALE_ENGLISH_NAMES,
  Locale,
  MOMENT_LOCALE_NAMES,
  NOT_LISTED_FIELD_NAME,
  ONE_DAY_IN_MILLISECONDS,
  ONE_HOUR_IN_MILLISECONDS,
  ONE_MINUTE_IN_MILLISECONDS,
  ONE_SECOND_IN_MILLISECONDS,
  ONE_WEEK_IN_MILLISECONDS,
  PASSWORD_MIN_LENGTH,
  PHONE_COUNTRIES,
  PREFERRED_LOCALE_COOKIE_NAME,
  PermissionType,
  PhoneNumberFactory,
  PopulationRelationship,
  RIGHT_TO_LEFT_LOCALES,
  RedirectWithNextParam,
  ReferrerProvider,
  ReleasedReportStates,
  SEXUAL_ORIENTATION_CAMEL_CASE_FIELD_NAMES,
  SEXUAL_ORIENTATION_FIELD_NAME,
  SEXUAL_ORIENTATION_SNAKE_CASE_FIELD_NAMES,
  SEX_AND_GENDER_IDENTITY_CAMEL_CASE_FIELD_NAMES,
  SEX_AND_GENDER_IDENTITY_SNAKE_CASE_FIELD_NAMES,
  SEX_ASSIGNED_AT_BIRTH_FIELD_NAME,
  SHORT_LOCALE_DISPLAY_NAMES,
  STI_TEST_TYPES,
  ScopedRoleType,
  SexAssignedAtBirth,
  SexualOrientationIdentity,
  US_STATES,
  US_TERRITORIES,
  UserPermission,
  UserRole,
  addToIsoDateString,
  appendQueryParams,
  calculateAge,
  clearBrowserStorage,
  q as convertObjectKeysToCamelCase,
  u as convertObjectKeysToSnakeCase,
  createAddressFromPartialValues,
  createFakeReactQueryClient,
  createMswGetHandler,
  createMswPatchHandler,
  createMswPostHandler,
  createMswPostHandlerSpy,
  extractDelimitedValues,
  formatAsE164,
  formatDate,
  formatDateRange,
  formatDateTime,
  formatDateTimeWithTimeZone,
  formatDateWithMonthAndYear,
  formatDateWithoutYear,
  formatIsoDateStringDateRange,
  formatIsoDateStringForTable,
  formatLongDate,
  formatLongDateTimeWithTimeZone,
  formatLongIsoDateString,
  formatPhoneNumber,
  formatPhoneNumberWithMask,
  formatShortDate,
  formatShortDateTime,
  formatShortIsoDateString,
  formatTime,
  formatTimeWithTimeZone,
  formatTimeZone,
  getAddressFieldOrder,
  getAgeInMonthsFromBirthdayIsoDateString,
  getAgeInYearsFromBirthdayIsoDateString,
  getCarrierOk,
  getCityLabel,
  getCityMaxlen,
  getCityWidth,
  p as getCsrfCookieName,
  getCurrentLocaleFromCookies,
  getCurrentPath,
  getDateFromIsoDateString,
  getDateFromTimeString,
  getDaysToDeliver,
  getDefaultPhoneNumber,
  getEndOfDayFromIsoDateString,
  getEnvironment,
  y as getEnvironmentOrDefault,
  o as getError,
  getFieldWidth,
  getFlagFilename,
  getFormattedDaysFromIsoDateStringDateRange,
  getFullName,
  getHoursInMilliseconds,
  getInstrumentedApp,
  getInvalidEmailErrorMessage,
  getIsoDateFieldsFromIsoDateString,
  getIsoDateStringAfterToday,
  getIsoDateStringBeforeToday,
  getIsoDateStringForToday,
  getIsoDateStringFromDate,
  getIsoDateStringFromIsoDateFields,
  getIsoDateStringFromIsoLongDateTimeString,
  getIsoDateStringFromUsDateString,
  getLatestSentryEventId,
  getMarketingUrl,
  getName,
  z as getNextSearchString,
  getOurGovtOk,
  getOutboundServiceName,
  getOutboundShipperName,
  getPasswordStrength,
  getPhoneMask,
  getPhonePrefix,
  getPostalCodeLabel,
  getPostalCodeMaxlen,
  getPostalCodeWidth,
  getQueryParam,
  B as getQueryParams,
  getRoles,
  getSafeNextQueryParam,
  C as getSafeUrl,
  D as getSafeVerifyEmailNextUrlQueryParam,
  getShippingChargeCents,
  getStartOfDayFromIsoDateString,
  getStateLabel,
  getStateMaxlen,
  getStateWidth,
  getTaxIdMaxlen,
  getTheirGovtOk,
  getTimeIntervalsArray,
  getUsDateStringFromIsoDateString,
  getValidLocale,
  hasAddressFieldForCountry,
  hasAnyRoles,
  hasMinimumAge,
  hasRole,
  identifyAnalyticsUser,
  initMonitoring,
  isAdult,
  isBirthdayIsoDateStringAdultAge,
  isBirthdayIsoDateStringAtLeastNYearsOld,
  isCountryShippable,
  isDefined,
  isEmailValid,
  x as isEnvironmentCypressTest,
  isEnvironmentLocal,
  w as isEnvironmentLocalAndDevelopment,
  isEnvironmentProduction,
  isEnvironmentStaging,
  v as isEnvironmentTesting,
  isInstanceOfIPhoneNumber,
  isIsoDateFieldsValid,
  isIsoDateStringAfter,
  isIsoDateStringBefore,
  isIsoDateStringValid,
  isObjKey,
  isRequiredFieldForCountryAddress,
  isUserAuthorized,
  logAnalyticsPageView,
  loggerUtils,
  mergeQueryParam,
  F as mergeQueryParams,
  navigateAndRefreshBrowser,
  openNewBrowserTab,
  parsePhoneNumber,
  reactQueryClient,
  resetAnalyticsUser,
  retry,
  scrollIntoView,
  setMockPreferredLocale,
  sortLocales,
  stripQueryParam,
  subtractFromIsoDateString,
  toIsoDateStringDateRange,
  toQueryString,
  trackAnalyticsEvent,
  G as trimTrailingSlash,
  useAnalytics,
  useAuthContext,
  useAuthorization,
  useCookiesContext,
  useDateFnsLocale,
  useIdentifyAnalyticsUser,
  useLaunchDarklyUpdater,
  useLocalStorageState,
  useLogPageViewUsingUniqueId,
  usePreferredLocale,
  useQueryParamLocale,
  useReferrerContext,
  useSessionStorageState,
  useUrlQueryParam,
  useUrlQueryParams,
  withDefaultProps
};
//# sourceMappingURL=index.js.map
